













































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import HintsContainer from '@/components/HintsContainer.vue';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ResultView from '@/components/ResultView.vue';
import SideToolbar from '@/components/SideToolbar.vue';
import {Generators, TableHeaders} from '@/interfaces/components-data';
import DatePicker from 'vue2-datepicker';
import moment, { Moment } from 'moment';
import {isNumber} from "lodash";
import SalesApi from "@/pages/Sales/SalesApi";

import {
    CalcIndividualConfig,
    Coefficents,
    ConfigMap,
    FindFiltersParams,
    IndividualConfig,
    PromoIndividualConfig,
    PromoType,
    SaleIndividualConfig,
    SaleServerIndividualConfig,
    SelectBox,
    StrategyOfPriceOpt,
    TaskInfoCalc,
} from '@/interfaces/global-data';
import {
    BaseFilterRoundingRules,
    CompetitorsPriceFilter,
    CompetitorsPricesView,
    GetTaskInfo,
    IErrors,
    InternalCodeAndProductRange,
    KviStrategies,
    NewProductPriceStrategy,
    PackagePromoConfig,
    ProductInfoResponseProperty,
    ProductSegmentIdAndName,
    PromoFilterProducts,
    PromoFilterType,
    SalesCalculationFilters,
    SalesFilters,
    Segment,
    Sku,
    SkuFilter,
    TaskAndFile,
    TaskInfoFilterType,
} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import LocalData, {ErrorsMap} from '@/mixins/local-data';
import {FormatNumber} from '@/numberFormatter';
import { Formatter } from '@/helpers/formatters';
import {BTabs} from 'bootstrap-vue';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import Toast from '@/mixins/toast';
import CollapseCard from "@/components/UI/CollapseCard.vue"
import Card from '@/components/UI/Card.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import {
    EntityMaskOptions,
    ISale,
    ISaleResponseDto,
    ISaleSaveDto,
    TaskTypeEntityProperties,
    EntityFilters,
    EntityFilterKeys,
} from "@/pages/Sales/data";
import Vue from "vue";


@Component({
    computed: {
        moment() {
          return moment;
        },
        PromoFilterType() {
            return PromoFilterType;
        },
        PromoFilterProducts() {
            return PromoFilterProducts;
        },
        TaskInfoFilterType() {
            return TaskInfoFilterType;
        }
    },
    components: {
        ResultView,
        SideToolbar,
        MultiSelect,
        MarketSelect,
        vSelect,
        HintsContainer,
        DatePicker,
        CollapseCard,
        Card,
        CSelect,
        SwitchWithLabel,
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD.MM.YYYY');
            }
        },
        formatRulesDate: (v: any) => {
            if (v) {
                return moment(moment.utc(v)).local().format('DD/MM/YYYY HH:mm:ss');
            }
        },
        formatCompetitorsDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('YYYY-MM-DD');
            }
        },
    },
    methods: {
        changeRowColor(item) {
            if (item !== null) {
                const index = this.$data.promoInternalCodesFromPromoFile.findIndex((v: string) => {
                    return v === item.internalCode;
                });
                if (index !== -1) {
                    return 'table-warning';
                }
            }
        },
        changeRowColorInDetailReport(item) {
            if (item !== null) {
                if (item.kvi === 'ДА') {
                    return 'table-primary';
                }
                if (item.resultType === 'COMPETITOR') {
                    return 'table-danger';
                }
            }
        },
        formatNumber(number) {
            if (String(number)[0] === '-') {
                return String(number).substring(0, 4);
            } else {
                return String(number).substring(0, 3);
            }
        },
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },
        replaceDecimalFormatter(value) {
            if (value == null) {
                return null
            } else {
                return parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
            }
        },
        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '').substring(0, 2);
            }
        },
        replaceTxtToNumberForRoundingRules(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '');
            }
        },
        isNumber,
    },
})
export default class Parameters extends Mixins(Toast, Http, LocalData) {
    @Prop({required: false}) readonly currentSale: ISaleResponseDto = {} as ISaleResponseDto;
    @Prop({required: true}) readonly errObj: any;

    @Watch('currentSale', {deep: true})
    onCurrentSaleChanged(currentSale: ISaleResponseDto, oldValue: ISaleResponseDto) {
        if (currentSale.id !== this.saleToEdit.id) {
            this.saleToEdit = Object.assign({}, this.currentSale);

            this.entityFilters.groupIds = this.saleToEdit.groups.map(el => el.id);
            this.entityFilters.categoryIds = this.saleToEdit.categories.map(el => el.id);
            this.entityFilters.subcategoryId = this.saleToEdit.subcategory ? this.saleToEdit.subcategory.id : 0;
            this.entityFilters.formatId = this.saleToEdit.format ? this.saleToEdit.format.id : 0;
            this.entityFilters.regionIds = this.saleToEdit.regions.map(el => el.id);
            this.entityFilters.clusterIds = this.saleToEdit.clusters.map(el => el.id);

            this.fetchEntityMaskSelectOptions(TaskInfoFilterType.group, 'entityGroupsSelectRef');
            this.fetchEntityMaskSelectOptions(TaskInfoFilterType.category, 'entityCategoriesSelectRef');
            this.fetchEntityMaskSelectOptions(TaskInfoFilterType.subcategory, 'entitySubcategorySelectRef');
            this.fetchEntityMaskSelectOptions(TaskInfoFilterType.format, 'entityFormatSelectRef');
            this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionsSelectRef');
            this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClustersSelectRef');

            this.tryFindParams();
        }
    }

    @Watch('errObj', {deep: true})
    onErrObjChanged() {
        if (this.errObj) {
            this.handleHttpError(this.errObj);
        } else {
            this.hideFormErrors('updateSale');
        }
    }

    @Watch('saleToEdit.startDate', {deep: true})
    @Watch('saleToEdit.endDate', {deep: true})
    @Watch('saleToEdit.stagesNumber', {deep: true})
    setSalesCalculationDay() {
        if (this.saleToEdit.startDate && this.saleToEdit.endDate && this.saleToEdit.stagesNumber) {
            const dateDiff: number = +new Date(this.saleToEdit.endDate) - +new Date(this.saleToEdit.startDate);

            if (dateDiff > 0) {
                const resValue: number = Math.floor(dateDiff / 84600000 / this.saleToEdit.stagesNumber);

                this.$sales.calculationDay = resValue >= 1 ? resValue : 1;

                if (!!this.periodForCalculatingEntered) {
                    this.periodForCalculatingEntered = null;
                }
            }
        }
    }

    parametersTabsHeight: string = '100%';

    entityFilters: EntityFilters = {
        groupIds: [],
        categoryIds: [],
        subcategoryId: null,
        formatId: null,
        regionIds: [],
        clusterIds: [],
    };

    saleToEdit: ISaleResponseDto = {
        id: null,
        startDate: null,
        endDate: null,
        name: null,
        type: null,
        status: null,
        stagesNumber: null,
        minSaleDiscount: null,
        maxSaleDiscount: null,
        minMargin: null,
        tradingId: null,
        groups: [{
            id: 0,
            name: ''
        }],
        categories: [{
            id: 0,
            name: ''
        }],
        subcategory: {
            id: 0,
            name: ''
        },
        format: {
            id: 0,
            name: ''
        },
        regions: [{
            id: 0,
            name: ''
        }],
        clusters: [{
            id: 0,
            name: ''
        }],
        skuCount: null,
        remains: null,
        taskId: null,
        revaluationFileName: null,
    };

    private periodForCalculatingEntered: string | number | null = null;

    private showFormError: boolean = false;
    private formErrors: ErrorsMap = {};

    file: File | null = null;
    productLineOptions: Array<SelectBox<string>> = [];
    productLineOptionsForFilter: Array<SelectBox<string>> = [];
    selectProductLine: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;

    productRangesArray: InternalCodeAndProductRange[] = [];

    defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};
    secondDefaultFilterValue = {value: -2, label: this.$t('shared.selectBox.empty') as string};

    selectProducts: PromoFilterProducts = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string}.value;
    selectProductsTypeForRecommends: PromoFilterProducts = PromoFilterProducts.ALL;
    selectProductsForPiRecommends: SelectBox<PromoFilterProducts> = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string};
    selectProductsForCdRecommends: SelectBox<PromoFilterProducts> = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string};
    selectProductsForIgRecommends: SelectBox<PromoFilterProducts> = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string};
    productFilterOptions: Array<SelectBox<PromoFilterProducts>> = [
        {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string},
        {value: PromoFilterProducts.PROMO, label: this.$t('shared.selectBox.promo') as string},
        {value: PromoFilterProducts.REGULAR, label: this.$t('shared.selectBox.regular') as string},
    ];

    selectKVI: number = this.defaultFilterValue.value;
    selectKVIForNewProducts: number = this.defaultFilterValue.value;
    selectKVIRecommends: number = this.defaultFilterValue.value;
    kviValueForRecommends: number = -1;
    selectKVIForPiRecommends: SelectBox<number> = this.defaultFilterValue;
    selectKVIForCdRecommends: SelectBox<number> = this.defaultFilterValue;
    selectKVIForIgRecommends: SelectBox<number> = this.defaultFilterValue;
    kviOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 1, label: 'KVI'},
        {value: 0, label: this.$t('shared.selectBox.notKvi') as string},
    ];

    kviRecommendsOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 0, label: this.$t('shared.selectBox.gk') as string},
        {value: 1, label: this.$t('shared.selectBox.cvk') as string},
    ];

    selectCTM: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
    selectCTMForNewProducts: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
    ctmValueForRecommends: string | null = null;
    selectCTMForPiRecommends: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    selectCTMForCdRecommends: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    selectCTMForIgRecommends: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    ctmOptions: Array<SelectBox<string>> = [
        {value: 'all', label: this.$t('shared.selectBox.all') as string},
        {value: '1', label: 'CTM'},
        {value: '0', label: this.$t('shared.selectBox.notCtm') as string},
    ];

    selectSegmentPrice: Segment[] = [];
    selectSegmentPriceForNewProducts: Segment[] = [];
    segmentPriceValueForRecommends: Segment[] = [];
    selectPiRecommendsSegmentPrice: Segment[] = [];
    selectCdRecommendsSegmentPrice: Segment[] = [];
    selectIgRecommendsSegmentPrice: Segment[] = [];
    segmentPriceOptions: Array<SelectBox<Segment>> = [];
    segmentPriceOptionsForNewProducts: Array<SelectBox<Segment>> = [];
    segmentPriceForRecommendsOptions: Array<SelectBox<Segment>> = [];
    selectProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    selectNewProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    newProductSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    productSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    tableKey = 1;
    competitorTableKey = 1;

    selectKeyCharacteristicOne: string[] = [];
    selectKeyCharacteristicTwo: string[] = [];
    selectRecipeAttributes: string[] = [];
    selectTreatmentAttributes: number[] = [];

    selectKeyCharacteristicOneForNewProduct: string[] = [];
    selectKeyCharacteristicTwoForNewProduct: string[] = [];
    selectRecipeAttributesForNewProduct: string[] = [];
    selectTreatmentAttributesForNewProduct: number[] = [];

    keyCharacteristicOneOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoOptions: Array<SelectBox<string>> = [];
    recipeAttributesOptions: Array<SelectBox<string>> = [];
    treatmentAttributesOptions: Array<SelectBox<number>> = [];

    keyCharacteristicOneForNewProductOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoForNewProductOptions: Array<SelectBox<string>> = [];
    recipeAttributesForNewProductOptions: Array<SelectBox<string>> = [];
    treatmentAttributesForNewProductOptions: Array<SelectBox<number>> = [];

    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        psegemnts: [],
    };
    taskInfoRecommends: TaskInfoCalc = {
        storeFormatOptions: [],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [],
        clusterOptions: [],
        groupsOfProduct: [],
        subcategories: [],
        subcategoriesDefault: [],
        psegemnts: [],
    };

    entityMaskOptions: EntityMaskOptions = {
        groups: [],
        categories: [],
        subcategories: [],
        formats: [],
        regions: [],
        clusters: [],
    };

    entityMaskOptionPropertyNames: TaskTypeEntityProperties = {
        group: 'groups',
        category: 'categories',
        subcategory: 'subcategories',
        format: 'formats',
        region: 'regions',
        cluster: 'clusters',
    }

    entityFiltersPropertyNames: TaskTypeEntityProperties = {
        group: 'groupIds',
        category: 'categoryIds',
        subcategory: 'subcategoryId',
        format: 'formatId',
        region: 'regionIds',
        cluster: 'clusterIds',
    }

    promoSkuOfferRunning: boolean = false;
    searchable: boolean = true;
    usePromoRecommendsFilter: boolean = false;
    skuFilter: string = '';
    newProductsFilter: string = '';
    skuRecommendsFilter: string = '';
    skuList: Sku[] = [];
    skuListWithAllProducts: Sku[] = [];
    newProductsList: Sku[] = [];
    newProductsListWithAllProducts: Sku[] = [];
    fileResult: string = '';
    taskId: number = 0;
    trafficGenerators: Generators[] = [];
    incomeGenerators: Generators[] = [];
    cartDrivers: Generators[] = [];
    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
    promoFilter: Array<SelectBox<PromoFilterType>> = [
        {value: PromoFilterType.all, label: this.$t('shared.selectBox.all') as string},
        {value: PromoFilterType.ig, label: this.$t('shared.selectBox.revenueGenerator') as string},
        {value: PromoFilterType.cd, label: this.$t('shared.selectBox.cartDriver') as string},
        {value: PromoFilterType.pi, label: this.$t('shared.selectBox.penetrationIndex') as string},
    ];
    selectedPromoFilter: PromoFilterType = {value: PromoFilterType.all, label: this.$t('shared.selectBox.all') as string}.value;
    recommendsType: PromoFilterType = PromoFilterType.pi;
    skuListLimit: number = 20;
    newProductsListLimit: number = 20;
    isNeedSaveParamsBeforeStartCalc: boolean = false;
    isCalculationButtonLoading: boolean = false;

    competitorsTable: any[] = [
        {
            dataIndex: 'selected',
            title: '✓',
            scopedSlots: { customRender: 'selected' },
            width: 70,
            fixed: 'left',
        },
        {
            dataIndex: 'internalCode',
            title: this.$t('results.tableHeaders.internalCode') as string,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'skuName',
            title: 'SKU',
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'lastPrice',
            title: this.$t('results.tableHeaders.lastPrice') as string,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'minCompetitorPrice',
            title: this.$t('results.tableHeaders.minCompetitorPrice') as string,
            customRender: (value: any) => `${this.numberFormatter(value.price)} (${value.name})`,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'maxCompetitorPrice',
            title: this.$t('results.tableHeaders.maxCompetitorPrice') as string,
            customRender: (value: any) => `${this.numberFormatter(value.price)} (${value.name})`,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'avgCompetitorPrices',
            title: this.$t('results.tableHeaders.avgCompetitorPrice') as string,
            customRender: (value: any) => this.numberFormatter(value.price),
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'lastPromoCompetitorPrice',
            title: this.$t('results.tableHeaders.lastPromoPrice') as string,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'minPromoCompetitorPrice',
            title: this.$t('results.tableHeaders.minPromoPrice') as string,
            customRender: (value: any) => value ? `${this.numberFormatter(value.price)} (${value.name})` : '',
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'maxPromoCompetitorPrice',
            title: this.$t('results.tableHeaders.maxPromoPrice') as string,
            customRender: (value: any) => value ? `${this.numberFormatter(value.price)} (${value.name})` : '',
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'medianPromoCompetitorPrice',
            title: this.$t('results.tableHeaders.medianPromoPrice') as string,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'kvi',
            title: 'KVI',
            customRender: (value: any) => value === 1 ? this.$t('shared.labels.yes') as string : this.$t('shared.labels.no') as string,
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'maxCompetitorsDate',
            title: this.$t('competitorsPricesList.tableHeaders.monitoringDate') as string,
            customRender: (value: any) => moment(new Date(+value)).format('YYYY-MM-DD'),
            width: 150,
            ellipsis: true,
        },
    ];

    taskData: TaskAndFile | null = null;

    competitors: CompetitorsPricesView[] = [];

    tableFields: TableHeaders[] = [
        {key: 'selected', label: ''},
        {key: 'internalCode', label: this.$t('results.tableHeaders.internalCode') as string},
        {key: 'productSegmentName', label: this.$t('results.tableHeaders.productSegment') as string},
        {key: 'skuName', label: 'SKU'},
        {key: 'tags', label: ''},
        {key: 'keyCharacteristicOfTheProductIsOne', label: this.$t('results.tableHeaders.kht1') as string},
        {key: 'keyCharacteristicOfTheProductIsTwo', label: this.$t('results.tableHeaders.kht2') as string},
        {key: 'recipeAttribute', label: this.$t('results.tableHeaders.prc') as string},
        {key: 'treatmentAttribute', label: this.$t('results.tableHeaders.pkl') as string},
        {key: 'promoType', label: this.$t('results.tableHeaders.promoType') as string},
        {key: 'lift', label: this.$t('shared.parametersTab.regularPriceCorrection') as string},
        {key: 'kvi', label: 'KVI'},
        {key: 'tagsKvi', label: ''},
        {key: 'ctm', label: 'CTM'},
        {key: 'minMaxRetailPrice', label: this.$t('results.tableHeaders.minMaxRc') as string},
        {key: 'productRange', label: this.$t('results.tableHeaders.line') as string},
        {key: 'lastPrice', label: this.$t('shared.labels.lastPrice') as string},
        {key: 'priceSegment', label: this.$t('results.tableHeaders.priceSegment') as string},
        {key: 'lastPriceMarginPc', label: this.$t('results.tableHeaders.marginLastPrice') as string},
        {key: 'actualProfitability', label: this.$t('shared.labels.actualProfitability') as string},
        {key: 'purchasePriceAvgM', label: this.$t('results.tableHeaders.avgPurchasePrice') as string},
        {key: 'purchasePrice', label: this.$t('results.tableHeaders.promoPurchasePrice') as string},
        {key: 'coefficentList', label: this.$t('results.tableHeaders.priceOptStrategy') as string},
        {key: 'priceIncreaseLimit', label: this.$t('results.tableHeaders.increaseLimit') as string},
        {key: 'periodPriceIncreaseLimit', label: this.$t('results.tableHeaders.periodPriceIncreaseLimit') as string},
        {key: 'period', label: this.$t('results.tableHeaders.period') as string},
        {key: 'marginalProfit', label: this.$t('results.tableHeaders.minMarginSku') as string},
        {key: 'kviStrategy', label: this.$t('results.tableHeaders.kviStrategy') as string},
        {key: 'percentageOfCompetitorsPrice', label: this.$t('results.tableHeaders.correction') as string},
    ];

    newTableFields: any[] = [
        {dataIndex: 'selected', title: '✓', scopedSlots: { customRender: 'selected', filterDropdown: 'selectedFilter', filterIcon: 'selectedFilterIcon' }, width: 60},
        {dataIndex: 'internalCode', title: this.$t('results.tableHeaders.internalCode') as string, width: 110, ellipsis: true},
        {dataIndex: 'productSegmentName', title: this.$t('results.tableHeaders.productSegment') as string, width: 150, ellipsis: true, scopedSlots: { filterDropdown: 'productSegmentNameFilter', filterIcon: 'productSegmentNameFilterIcon'}},
        {dataIndex: 'skuName', width: 170, ellipsis: true, scopedSlots: { title: 'sku', filterDropdown: 'skuFilter', filterIcon: 'skuFilterIcon' }},
        {dataIndex: 'tags', title: '', width: 100, scopedSlots: { customRender: 'tags' }},
        {dataIndex: 'keyCharacteristicOfTheProductIsOne', title: this.$t('results.tableHeaders.kht1') as string, width: 150, ellipsis: true, scopedSlots: { filterDropdown: 'kxt1Filter', filterIcon: 'kxt1FilterIcon' }},
        {dataIndex: 'keyCharacteristicOfTheProductIsTwo', title: this.$t('results.tableHeaders.kht2') as string, width: 150, ellipsis: true, scopedSlots: { filterDropdown: 'kxt2Filter', filterIcon: 'kxt2FilterIcon' }},
        {dataIndex: 'recipeAttribute', title: this.$t('results.tableHeaders.prc') as string, width: 150, ellipsis: true, scopedSlots: { filterDropdown: 'prcFilter', filterIcon: 'prcFilterIcon' }},
        {dataIndex: 'treatmentAttribute', title: this.$t('results.tableHeaders.pkl') as string, width: 150, ellipsis: true, scopedSlots: { filterDropdown: 'pklFilter', filterIcon: 'pklFilterIcon' }},
        {dataIndex: 'promoType', title: this.$t('results.tableHeaders.promoType') as string, scopedSlots: { customRender: 'promoType' }, width: 100},
        {dataIndex: 'lift', title: this.$t('shared.parametersTab.regularPriceCorrection') as string, scopedSlots: { customRender: 'lift' }, width: 130},
        {dataIndex: 'kvi', title: 'KVI', scopedSlots: { customRender: 'kvi', filterDropdown: 'kviFilter', filterIcon: 'kviFilterIcon' }, width: 50},
        {dataIndex: 'tagsKvi', title: '', scopedSlots: { customRender: 'tagsKvi', filterDropdown: 'tagsKviFilter', filterIcon: 'tagsKviFilterIcon' }, width: 100},
        {dataIndex: 'ctm', title: 'CTM', width: 70, ellipsis: true, scopedSlots: { filterDropdown: 'ctmFilter', filterIcon: 'ctmFilterIcon' }},
        {dataIndex: 'minMaxRetailPrice', title: this.$t('results.tableHeaders.minMaxRc') as string, scopedSlots: { customRender: 'minMaxRetailPrice' }, width: 100},
        {dataIndex: 'productRange', title: this.$t('results.tableHeaders.line') as string, scopedSlots: { customRender: 'productRange', filterDropdown: 'productRangeFilter', filterIcon: 'productRangeFilterIcon' }, width: 100},
        {dataIndex: 'lastPrice', scopedSlots: { customRender: 'lastPrice', title: 'lastPriceTitle' }, width: 100},
        {dataIndex: 'priceSegment', title: this.$t('results.tableHeaders.priceSegment') as string, scopedSlots: { customRender: 'priceSegment', filterDropdown: 'priceSegmentFilter', filterIcon: 'priceSegmentFilterIcon' }, width: 110},
        {dataIndex: 'lastPriceMarginPc', title: this.$t('results.tableHeaders.marginLastPrice') as string, width: 100},
        {dataIndex: 'actualProfitability', scopedSlots: { customRender: 'actualProfitability', title: 'actualProfitabilityTitle' }, width: 110},
        {dataIndex: 'purchasePriceAvgM', title: this.$t('results.tableHeaders.avgPurchasePrice') as string, scopedSlots: { customRender: 'purchasePriceAvgM' }, width: 70},
        {dataIndex: 'purchasePrice', title: this.$t('results.tableHeaders.promoPurchasePrice') as string, scopedSlots: { customRender: 'purchasePrice' }, width: 100},
        {dataIndex: 'coefficentList', title: this.$t('results.tableHeaders.priceOptStrategy') as string, scopedSlots: { customRender: 'coefficentList' }, width: 170},
        {dataIndex: 'priceIncreaseLimit', title: this.$t('results.tableHeaders.increaseLimit') as string, scopedSlots: { customRender: 'priceIncreaseLimit' }, width: 110},
        {dataIndex: 'periodPriceIncreaseLimit', title: this.$t('results.tableHeaders.periodPriceIncreaseLimit') as string, scopedSlots: { customRender: 'periodPriceIncreaseLimit' }, width: 150},
        {dataIndex: 'period', title: this.$t('results.tableHeaders.period') as string, scopedSlots: { customRender: 'period' }, width: 100},
        {dataIndex: 'marginalProfit', title: this.$t('results.tableHeaders.minMarginSku') as string, scopedSlots: { customRender: 'marginalProfit' }, width: 150},
        {dataIndex: 'maxMarginalProfit', title: this.$t('results.tableHeaders.maxMarginSku') as string, scopedSlots: { customRender: 'maxMarginalProfit' }, width: 150},
        {dataIndex: 'kviStrategy', title: this.$t('results.tableHeaders.kviStrategy') as string, scopedSlots: { customRender: 'kviStrategy' }, width: 150, ellipsis: true},
        {dataIndex: 'percentageOfCompetitorsPrice', title: this.$t('results.tableHeaders.correction') as string, scopedSlots: { customRender: 'percentageOfCompetitorsPrice' }, width: 150},
        {
          dataIndex: 'productVolume',
          title: this.$t('results.tableHeaders.productVolume') as string,
          customRender: (value: any) => this.numberFormatter(value),
          ellipsis: false,
          width: 40,
        },
        {
          dataIndex: 'measurementUnit',
          title: this.$t('results.tableHeaders.measurementUnit') as string,
          ellipsis: false,
          width: 30,
        },
        {
          dataIndex: 'productVerticalLine',
          title: this.$t('results.tableHeaders.productVerticalLine') as string,
          ellipsis: true,
          width: 70,
        },
        {
          dataIndex: 'isVerticalLineBase',
          title: this.$t('results.tableHeaders.isVerticalLineBase') as string,
          customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
          ellipsis: false,
          width: 50,
        },
        {
          dataIndex: 'vlStrategyStr',
          title: this.$t('results.tableHeaders.vlStrategyStr') as string,
          ellipsis: false,
          width: 70,
        },
        {
          dataIndex: 'vlGapPc',
          title: this.$t('results.tableHeaders.vlGapPc') as string,
          customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
          ellipsis: false,
          width: 70,
        },
    ];
    skuPagination: any = {
        pageSize: 20,
        current: 1,
    };
    newProductsPagination: any = {
        pageSize: 20,
        current: 1,
    };

    newProductsTableFields: TableHeaders[] = [
        {key: 'internalCode', label: this.$t('results.tableHeaders.internalCode') as string},
        {key: 'productSegmentName', label: this.$t('results.tableHeaders.productSegment') as string},
        {key: 'skuName', label: 'SKU'},
        {key: 'keyCharacteristicOfTheProductIsOne', label: this.$t('results.tableHeaders.kht1') as string},
        {key: 'keyCharacteristicOfTheProductIsTwo', label: this.$t('results.tableHeaders.kht2') as string},
        {key: 'recipeAttribute', label: this.$t('results.tableHeaders.prc') as string},
        {key: 'treatmentAttribute', label: this.$t('results.tableHeaders.pkl') as string},
        {key: 'promoType', label: this.$t('results.tableHeaders.promoType') as string},
        {key: 'lift', label: this.$t('shared.parametersTab.regularPriceCorrection') as string},
        {key: 'kvi', label: 'KVI'},
        {key: 'ctm', label: 'CTM'},
        {key: 'minMaxRetailPrice', label: this.$t('results.tableHeaders.minMaxRc') as string},
        {key: 'productRange', label: this.$t('results.tableHeaders.line') as string},
        {key: 'lastPrice', label: this.$t('shared.labels.lastPrice') as string},
        {key: 'priceSegment', label: this.$t('results.tableHeaders.priceSegment') as string},
        {key: 'actualProfitability', label: this.$t('shared.labels.actualProfitability') as string},
        {key: 'purchasePriceAvgM', label: this.$t('results.tableHeaders.avgPurchasePrice') as string},
        {key: 'purchasePrice', label: this.$t('results.tableHeaders.promoPurchasePrice') as string},
        {key: 'coefficentList', label: this.$t('results.tableHeaders.priceOptStrategy') as string},
        {key: 'marginalProfit', label: this.$t('results.tableHeaders.minMarginSku') as string},
        {key: 'maxMarginalProfit', label: this.$t('results.tableHeaders.maxMarginSku') as string},
        {key: 'kviStrategy', label: this.$t('results.tableHeaders.kviStrategy') as string},
        {key: 'percentageOfCompetitorsPrice', label: this.$t('results.tableHeaders.correction') as string},
        {key: 'newProductPriceStrategy', label: this.$t('results.tableHeaders.newProductPriceStrategy') as string},
        {key: 'priceGap', label: this.$t('results.tableHeaders.priceGap') as string},
    ];

    newNewProductsTableFields: any[] = [
        {dataIndex: 'internalCode', title: this.$t('results.tableHeaders.internalCode') as string, width: 120},
        {dataIndex: 'productSegmentName', title: this.$t('results.tableHeaders.productSegment') as string, width: 130, scopedSlots: { filterDropdown: 'productSegmentNameFilter', filterIcon: 'productSegmentNameFilterIcon'}, ellipsis: true},
        {dataIndex: 'skuName', scopedSlots: { title: 'sku' }, width: 110, ellipsis: true},
        {dataIndex: 'keyCharacteristicOfTheProductIsOne', title: this.$t('results.tableHeaders.kht1') as string, width: 150, scopedSlots: { filterDropdown: 'kxt1Filter', filterIcon: 'kxt1FilterIcon' }, ellipsis: true},
        {dataIndex: 'keyCharacteristicOfTheProductIsTwo', title: this.$t('results.tableHeaders.kht2') as string, width: 150, scopedSlots: { filterDropdown: 'kxt2Filter', filterIcon: 'kxt2FilterIcon' }, ellipsis: true},
        {dataIndex: 'recipeAttribute', title: this.$t('results.tableHeaders.prc') as string, width: 150, scopedSlots: { filterDropdown: 'prcFilter', filterIcon: 'prcFilterIcon' }, ellipsis: true},
        {dataIndex: 'treatmentAttribute', title: this.$t('results.tableHeaders.pkl') as string, width: 150, scopedSlots: { filterDropdown: 'pklFilter', filterIcon: 'pklFilterIcon' }, ellipsis: true},
        {dataIndex: 'promoType', title: this.$t('results.tableHeaders.promoType') as string, scopedSlots: { customRender: 'promoType' }, width: 100},
        {dataIndex: 'lift', title: this.$t('shared.parametersTab.regularPriceCorrection') as string, scopedSlots: { customRender: 'lift' }, width: 130},
        {dataIndex: 'kvi', title: 'KVI', scopedSlots: { customRender: 'kvi', filterDropdown: 'kviFilter', filterIcon: 'kviFilterIcon' }, width: 80},
        {dataIndex: 'ctm', title: 'CTM', width: 80, scopedSlots: { filterDropdown: 'ctmFilter', filterIcon: 'ctmFilterIcon' }, ellipsis: true},
        {dataIndex: 'minMaxRetailPrice', title: this.$t('results.tableHeaders.minMaxRc') as string, scopedSlots: { customRender: 'minMaxRetailPrice' }, width: 100},
        {dataIndex: 'productRange', title: this.$t('results.tableHeaders.line') as string, width: 100},
        {dataIndex: 'lastPrice', scopedSlots: { customRender: 'lastPrice', title: 'lastPriceTitle' }, width: 100},
        {dataIndex: 'priceSegment', title: this.$t('results.tableHeaders.priceSegment') as string, scopedSlots: { customRender: 'priceSegment', filterDropdown: 'priceSegmentFilter', filterIcon: 'priceSegmentFilterIcon' }, width: 110},
        {dataIndex: 'actualProfitability', scopedSlots: { customRender: 'actualProfitability', title: 'actualProfitabilityTitle' }, width: 120},
        {dataIndex: 'purchasePriceAvgM', title: this.$t('results.tableHeaders.avgPurchasePrice') as string, scopedSlots: { customRender: 'purchasePriceAvgM' }, width: 100},
        {dataIndex: 'purchasePrice', label: this.$t('results.tableHeaders.promoPurchasePrice') as string, scopedSlots: { customRender: 'purchasePrice' }, width: 150},
        {dataIndex: 'coefficentList', title: this.$t('results.tableHeaders.priceOptStrategy') as string, scopedSlots: { customRender: 'coefficentList' }, width: 130},
        {dataIndex: 'marginalProfit', title: this.$t('results.tableHeaders.minMarginSku') as string, scopedSlots: { customRender: 'marginalProfit' }, width: 150},
        {dataIndex: 'maxMarginalProfit', title: this.$t('results.tableHeaders.maxMarginSku') as string, scopedSlots: { customRender: 'maxMarginalProfit' }, width: 150},
        {dataIndex: 'kviStrategy', title: this.$t('results.tableHeaders.kviStrategy') as string, scopedSlots: { customRender: 'kviStrategy' }, width: 110},
        {dataIndex: 'percentageOfCompetitorsPrice', title: this.$t('results.tableHeaders.correction') as string, scopedSlots: { customRender: 'percentageOfCompetitorsPrice' }, width: 150},
        {dataIndex: 'newProductPriceStrategy', title: this.$t('results.tableHeaders.newProductPriceStrategy') as string, scopedSlots: { customRender: 'newProductPriceStrategy' }, width: 160, ellipsis: true},
        {dataIndex: 'priceGap', title: this.$t('results.tableHeaders.priceGap') as string, scopedSlots: { customRender: 'priceGap' }, width: 100},
        {
          dataIndex: 'productVolume',
          title: this.$t('results.tableHeaders.productVolume') as string,
          customRender: (value: any) => this.numberFormatter(value),
          ellipsis: false,
          width: 40,
        },
        {
          dataIndex: 'measurementUnit',
          title: this.$t('results.tableHeaders.measurementUnit') as string,
          ellipsis: false,
          width: 30,
        },
        {
          dataIndex: 'productVerticalLine',
          title: this.$t('results.tableHeaders.productVerticalLine') as string,
          ellipsis: true,
          width: 70,
        },
        {
          dataIndex: 'isVerticalLineBase',
          title: this.$t('results.tableHeaders.isVerticalLineBase') as string,
          customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
          ellipsis: false,
          width: 50,
        },
        {
          dataIndex: 'vlStrategyStr',
          title: this.$t('results.tableHeaders.vlStrategyStr') as string,
          ellipsis: false,
          width: 70,
        },
        {
          dataIndex: 'vlGapPc',
          title: this.$t('results.tableHeaders.vlGapPc') as string,
          customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
          ellipsis: false,
          width: 70,
        },
    ];
    rulesTableFields: TableHeaders[] = [
        {key: 'fileDownload', label: this.$t('shared.labels.actions') as string},
        {key: 'errors', label: this.$t('shared.labels.errors') as string},
        {key: 'uploadDate', label: this.$t('shared.labels.modifiedDate') as string},
        {key: 'user', label: this.$t('shared.labels.user') as string},
        {key: 'storeFormat', label: this.$t('shared.filters.storeFormatChannel') as string},
        {key: 'storeRegions', label: this.$t('shared.filters.storeRegion') as string},
        {key: 'storeCluster', label: this.$t('shared.filters.storeCluster') as string},
        {key: 'groupsOfProduct', label: this.$t('results.tableHeaders.productGroup') as string},
        {key: 'categories', label: this.$t('results.tableHeaders.productCategory') as string},
        {key: 'subcategories', label: this.$t('shared.parametersTab.subcategory') as string},
    ];

    newRulesTableFields: any[] = [
        {
            dataIndex: 'fileDownload',
            title: this.$t('shared.labels.actions') as string,
            scopedSlots: { customRender: 'fileDownload' },
        },
        {
            dataIndex: 'errors',
            title: this.$t('shared.labels.errors') as string,
            scopedSlots: { customRender: 'errors' }},
        {
            dataIndex: 'uploadDate',
            title: this.$t('shared.labels.modifiedDate') as string,
            customRender: (value: number) => moment(moment.utc(value)).local().format('DD/MM/YYYY HH:mm:ss'),
            scopedSlots: { filterDropdown: 'uploadDateFilter', filterIcon: "uploadDateFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'user',
            title: this.$t('shared.labels.user') as string,
            scopedSlots: { filterDropdown: 'userFilter', filterIcon: "userFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'storeFormat',
            title: this.$t('shared.filters.storeFormatChannel') as string,
            scopedSlots: { filterDropdown: 'storeFormatFilter', filterIcon: "storeFormatFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'storeRegions',
            title: this.$t('shared.filters.storeRegion') as string,
            scopedSlots: { filterDropdown: 'storeRegionsFilter', filterIcon: "storeRegionsFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'storeCluster',
            title: this.$t('shared.filters.storeCluster') as string,
            scopedSlots: {filterDropdown: 'storeClusterFilter', filterIcon: "storeClusterFilterIcon"},
            ellipsis: true,
        },
        {
            dataIndex: 'groupsOfProduct',
            title: this.$t('results.tableHeaders.productGroup') as string,
            scopedSlots: { filterDropdown: 'groupsOfProductFilter', filterIcon: "groupsOfProductFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'categories',
            title: this.$t('results.tableHeaders.productCategory') as string,
            scopedSlots: { filterDropdown: 'categoriesFilter', filterIcon: "categoriesFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'subcategories',
            title: this.$t('shared.parametersTab.subcategory') as string,
            scopedSlots: { filterDropdown: 'subcategoriesFilter', filterIcon: "subcategoriesFilterIcon" },
            ellipsis: true,
        },
    ];

    tableData: any = [];
    pagination: any = {
        pageSize: 20,
    };

    loadingConfigs = false;
    marginalErrorText = ''
    maxMarginalErrorText = ''
    marginalSkuErrorText = ''
    incorrectPeriodErrorText = '';
    globalNewProductIndividualMarginalErrorText = '';
    globalIndividualMarginalErrorText = '';
    competitorsMaximumProfitPromoErrorText = '';
    globalNewProductIndividualMarginalBlockButton = false;
    globalLiftBlockButton = false;
    globalNewProductLiftBlockButton = false;
    globalIndividualMarginalBlockButton = false;
    globalIndividualPeriodPriceIncreaseLimitBlockButton = false;
    globalIndividualPriceIncreaseLimitBlockButton = false;

    downloadLastExcelHeaderByFilters: boolean = false;
    downloadLastExcelDetailByFilters = false;
    skuListPerPage = 20;
    newProductListPerPage: number = 20;
    skuListCurrentPage: number = 1;
    skuRecommendsListCurrentPage: number = 1;
    newProductsListCurrentPage: number = 1;
    skuListTotalRows: number = 0;
    newProductsListTotalRows: number = 0;
// tslint:disable-next-line: ban-types
    onDropdownClosed: Function | null = null;
    needLoadSkuList: boolean = false;
    showBookmarks: boolean = true;
    showPromoRecommendsBookmarks: boolean = true;
    showMainFilters: boolean = true;
    showMainRecommendsFilters: boolean = true;
    needLoadNewProductList: boolean = false;
    firstDate: number = 0;
    lastDate: number = 0;
    calcModalShow: boolean = false;
    recalculatingRegularPricesModalShow: boolean = false;
    isActualProfitabilityCalculated: boolean = false;
    isRegularPricesProfitabilityCalculated: boolean = false;
    isDataRangeCalculated: boolean = false;
    isPriceCorridorCalculated: boolean = false;
    isFetchSkuListDownload: boolean = false;
    isFetchNewProductsListDownload: boolean = false;
    isLoadCompetitorPrices: boolean = false;
    kviSaveProcess: boolean = false;
    calcSkuActualProfitButtonDisabled: boolean = false;
    newProductsLastPage: number = 0;
    calcSkuLastPricesButtonDisabled: boolean = false;
    useFindKviRecommendsParam: boolean = false;
    tabs: BTabs | null = null;
    isFiltersChangedForRecommends = 1;
    loadProgress: boolean = false;
    progressCounter: number = 0;
    rulesCurrentPage = 1;
    rulesTotalRows = 0;
    rulesPerPage = 20;
    rulesTableKey = 1;
    rulesDateRange: string[] = [];
    showDeleteFileModal: boolean = false;
    fileIdForDelete: number = -1;
    serverConfigTimeout: number | null = null;
    currentMainTab: string = "mainParameters"

    selectUserFio: string = 'All';
    usersFioList: Array<SelectBox<string>> = [];

    selectTradingFilter: SelectBox<number> = this.defaultFilterValue;
    tradingsFilterOptions: Array<SelectBox<number>> = [];

    selectCategoryFilter: number = this.defaultFilterValue.value;
    categoryFilterOptions: Array<SelectBox<number>> = [];

    selectGroupFilter: number = this.defaultFilterValue.value;
    groupFilterOptions: Array<SelectBox<number>> = [];

    selectSubcategoryFilter: number = this.defaultFilterValue.value;
    subcategoryFilterOptions: Array<SelectBox<number>> = [];

    selectFormatFilter: number = this.defaultFilterValue.value;
    formatFilterOptions: Array<SelectBox<number>> = [];

    selectRegionFilter: number = this.defaultFilterValue.value;
    regionFilterOptions: Array<SelectBox<number>> = [];

    selectClusterFilter: number = this.defaultFilterValue.value;
    clusterFilterOptions: Array<SelectBox<number>> = [];

    isFixPricePromo: boolean = false;

    private globalIndividualPromoType: SelectBox<PromoType> | null = null;
    private globalIndividualLift: number | null = null;
    private globalIndividualPromoPurchasePrice: number | null = null;
    private globalIndividualPriceStrategy: SelectBox<Coefficents> | null = null;
    private globalIndividualPriceIncreaseLimit: number | null = null;
    private globalIndividualPeriodPriceIncreaseLimit: number | null = null;
    private globalIndividualPeriod: SelectBox<number> | null = null;
    private globalIndividualMarginalProfitability: number | null = null;
    private globalIndividualKviStrategy: SelectBox<KviStrategies> | null = null;

    private globalIndividualPercentageOfCompetitorsPrice: string | null = null;
    private globalIndividualNewProductPromoType: SelectBox<PromoType> | null = null;
    private globalIndividualNewProductLift: number | null = null;
    private globalIndividualNewProductPromoPurchasePrice: number | null = null;
    private globalIndividualNewProductStrategyOpt: SelectBox<Coefficents> | null = null;
    private globalIndividualNewProductMarginalProfitability: number | null = null;
    private globalIndividualNewProductKviStrategy: SelectBox<KviStrategies> | null = null;
    private globalIndividualNewProductPercentageOfCompetitorsPrice: string | null = null;
    private globalIndividualNewProductPriceStrategy: SelectBox<NewProductPriceStrategy> | null = null;

    private globalIndividualNewProductPriceGap: number | null = null;
    private refreshSkuListId = -1;
    private refreshNewProductsListId = -1;
    private refreshAllRecommendsId = -1;
    private refreshPiRecommendsId = -1;
    private refreshCdRecommendsId = -1;
    private refreshIgRecommendsId = -1;
    private dropDownOpen = false;
    private dropDownOpenForRoundingRules = false;
    // tslint:disable-next-line: ban-types
    private onDropdownClosedForRoundingRules: Function | null = null;
    private showSku: boolean = false;
    private showSkuAndSearch: boolean = true;
    private skuListWithCalculating: boolean = false;
    private newProductsWithCalculating: boolean = true;
    private skuRecommendsCalculate: boolean = false;
    private httpExecutor: HttpExecutor = new HttpExecutor();
    private showDataRange: boolean = false;
    private sortBySKU: number = -1;
    private sortingNewProductsBySKU: number = -1;
    private sortBySKUForPiRecommends: number = -1;
    private sortBySKUForCdRecommends: number = -1;
    private sortBySKUForIgRecommends: number = -1;
    private sortBySKUValueForRecommends: number = -1;
    private actualProfitability: number | null = null;
    private regularPricesProfitability: number | null = null;
    private isFiltersChanged = 1;
    private lastPage = 0;
    private findAutomaticallyPriceSegments = false;
    private countPriceSegments = 1;
    private productCodesForAddKvi: string[] = []
    private productCodesForDeleteKvi: string[] = []
    private productCodesForAddCtmPurpose: string[] = []
    private productCodesForDeleteCtmPurpose: string[] = []
    private needCalculateSkuLastPricesOnly: boolean = false;

    private needCalculateSkuActualProfitabilityOnly: boolean = false;
    private promoInternalCodesFromPromoFile: string[] = []

    private promoDisabledInternalCodes: string[] = []

    private viz: any | null = null;
    private rulesLimit: number = 20;
    private refreshRulesListId = -1;
    private needLoadFiltersForTable: boolean = true;

    private api: SalesApi = new SalesApi({parent: this});

    private saveSale(params: ISaleSaveDto): Promise<any> {
        return new Promise<ISale>((resolve, reject) => {
            this.api.saveSale(params)
                .then((res) => {
                    resolve(res as any);
                })
                .catch((err) => {
                    reject(err);
                    this.showError(this.$t('shared.parametersTab.errorSaveSale') as string);
                })
        })
    }

    async updateBasicSaleParams() {
        let saleToSave: ISale | ISaleSaveDto = Object.assign({}, this.saleToEdit);

        if (this.$sales.selectMarket.id != null) {
            Object.assign(saleToSave, {
                id: this.saleToEdit.id,
                tradingId: this.saleToEdit.tradingId,
                groupIds: this.entityFilters.groupIds.realValuesOrEmpty(),
                categoryIds: this.entityFilters.categoryIds.realValuesOrEmpty(),
                subcategoryId: this.entityFilters.subcategoryId ? this.entityFilters.subcategoryId : null,
                formatId: this.entityFilters.formatId ? this.entityFilters.formatId : null,
                regionIds: this.entityFilters.regionIds.realValuesOrEmpty(),
                clusterIds: this.entityFilters.clusterIds.realValuesOrEmpty(),
            });
        }

        await this.saveSale(saleToSave)
            .then((res) => {
                this.$emit('basic-sale-params-updated', {
                    success: true,
                    data: res.data,
                });
            })
            .catch((err) => {
                this.$emit('basic-sale-params-updated', {
                    success: false,
                    err,
                });
            });
    }

    tryFindRulesParams() {
        this.serverConfigTimeout = null;
        const [selectSeasons, selectRegions] = this.selectDataForRoundingRulesSeasonsRegions();
        const findParams = new FindFiltersParams();
        findParams.tradingId = this.$roundingRules.selectMarket.id;
        findParams.groupOfProduct = this.$roundingRules.groupOfProduct;
        findParams.category = this.$roundingRules.categoryOfProduct;
        // tslint:disable-next-line: no-non-null-assertion
        findParams.subcategories = LocalData.filterNumberArrays(this.$roundingRules.subcategories)!!;
        findParams.storeCluster = this.$roundingRules.clusterSelected == null ? null : this.$roundingRules.clusterSelected;
        findParams.seasonValues = selectSeasons;
        findParams.storeRegionValues = selectRegions;
        findParams.storeFormat = this.$roundingRules.formatSelected;
        findParams.categoryStrategy = this.$roundingRules.categoryStrategy.value

        if (findParams.canLoadRoundingRules()) {
            this.loadingConfigs = true;
            this.httpFindRulesParams(findParams, 'PROMO')
                    .then((r) => {
                        const params = r.data;
                        this.$roundingRules.pennies = params.pennies
                        this.$roundingRules.allNewPricesWithoutPennies = params.allNewPricesWithoutPennies
                        this.$roundingRules.roundKviCompetitorPrice = params.roundKviCompetitorPrice
                        this.$roundingRules.roundPricesWithEqualCompStrategy = params.roundPricesWithEqualCompStrategy
                        this.$roundingRules.randomPennies = params.randomPennies
                        this.$roundingRules.bigDigit = params.bigDigit
                        this.$roundingRules.manualPennies = params.manualPennies

                        this.loadingConfigs = false
                    })
                    .catch((e) => {
                        this.loadingConfigs = false;
                        this.$log.error('Error occurred while loading configs', e);
                        this.showError(this.$t('shared.parametersTab.errorLoadParams') as string);
                    })
        }
    }

    async saveRulesParams() {
        const filters = this.getRulesFilters();

        this.httpSaveRulesParams(filters)
                .then((r) => {
                    this.$log.debug('Параметры сохранены', r.data);
                    this.showInfo(this.$t('shared.parametersTab.saveParamsSuccess') as string);
                })
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorSaveCalcParams') as string + e);
                })
    }

    getRulesFilters(): BaseFilterRoundingRules {
        return {
            filterType: 'PROMO',
            tradingId: this.$roundingRules.selectMarket.id,
            category: this.$roundingRules.categoryOfProduct,
            groupOfProduct: this.$roundingRules.groupOfProduct,
            seasonValues: this.$roundingRules.seasonSelected,
            buyerSegments: this.$roundingRules.buyerSegmentsList,
            storeRegionValues: this.$roundingRules.regionSelected,
            categoryStrategy: this.$roundingRules.categoryStrategy.value,
            storeFormat: this.$roundingRules.formatSelected,
            subcategories: this.$roundingRules.subcategories,
            productSegments: this.$roundingRules.productSegments,
            allNewPricesWithoutPennies: this.$roundingRules.allNewPricesWithoutPennies,
            storeCluster: this.$roundingRules.clusterSelected,
            pennies: this.$roundingRules.pennies,
            randomPennies: this.$roundingRules.randomPennies,
            roundKviCompetitorPrice: this.$roundingRules.roundKviCompetitorPrice,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            bigDigit: this.$roundingRules.bigDigit,
            manualPennies: this.$roundingRules.manualPennies,
        }
    }

    numberFormatter = (v: any): string => FormatNumber.format(v);

    searchPackagePromoRecommends() {
        const filters = this.getPackagePromoRecommendsFilter();
        this.savePackagePromoRecommends();
        this.httpAddPackagePromoRecommendsTask(filters)
                .then((r) => {
                  this.showInfo(this.$t('shared.parametersTab.calcStarted') as string);
                  this.$log.debug('Create task', r.data);
                })
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorStartCalc') as string);
                });
    }

    mounted() {
        this.setParamsVerticalTabsHeight();

        this.tabs = this.$refs.mainTabs as BTabs;

        this.$sales.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('shared.parametersTab.maxGrossMargin') as string}
    }

    beforeDestroy() {
        this.$calc.hintsLoaded = false
        this.$calc.currentModuleHints = [];
    }

    destroyed() {
        if (this.viz != null) {
            this.viz.dispose();
        }
    }

    created() {
        this.httpLoadModuleHints('Promo').then((r) => {
            this.$calc.currentModuleHints = r.data
            this.$calc.hintsLoaded = true
        }).catch((e) => {
        });
    }

    dataRangeInfo() {
        if (!this.showDataRange) {
            return;
        }
        if (this.$sales.selectMarket.id === -1 || !this.$sales.categoryIds.length) {
            this.firstDate = 0;
            this.lastDate = 0;
            return;
        }
        this.isDataRangeCalculated = true;

        const filters = this.getSalesFilter();
        this.httpExecutor.executeHttp(this.httpPostDataRange, filters)
                .then((d) => {
                            if (!d.ignore) {
                                const r = d.response;
                                if (r.data.firstDate == null && r.data.lastDate == null) {
                                    this.firstDate = 0;
                                    this.lastDate = 0;
                                    this.showInfo(this.$t('shared.parametersTab.noDateRangeData') as string);
                                    this.isDataRangeCalculated = false;
                                } else {
                                    this.firstDate = r.data.firstDate;
                                    this.lastDate = r.data.lastDate;
                                    this.isDataRangeCalculated = false;
                                }
                            }
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorGetDateRange') as string);
                    this.$log.error('Error occurred [load data range]', e);
                    this.isDataRangeCalculated = false;
                });
    }

    resetTables() {
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
    }

    resetActualProfitability() {
        this.actualProfitability = null;
    }

    resetRegularPricesProfitability() {
        this.regularPricesProfitability = null;
    }

    resetCompetitors() {
        this.competitors = [];
        this.$sales.competitorsCodes = [];
    }

    hideNewProductPricingPanel(): boolean {
        return this.$disallowedModules.includes('newProduct-pricing');
    }

    tryFindParams() {
        // const [selectSeasons, selectRegions] = this.selectData();

        // temporary - must request from server (need route)
        this.saleToEdit = Object.assign({}, this.currentSale);

        const findParams = new FindFiltersParams();
        findParams.tradingId = this.saleToEdit.tradingId;
        findParams.saleId = this.saleToEdit.id;
        findParams.groupOfProduct = null;
        findParams.category = null;
// tslint:disable-next-line: no-non-null-assertion
        findParams.subcategories = [];
// tslint:disable-next-line: no-non-null-assertion
        findParams.productSegments = [];
        findParams.storeCluster = null;
        findParams.seasonValues = [];
        findParams.storeRegionValues = [];
        findParams.storeFormat = null;
        findParams.categoryStrategy =  this.$roundingRules.categoryStrategy.value;

        if (findParams.canLoadSaleParams()) {
            this.loadingConfigs = true;

            this.loadCommonParams(findParams)
                    .catch((e) => {
                        this.loadingConfigs = false;
                        this.$log.error('Error occurred while loading configs', e);
                        this.showError(this.$t('shared.parametersTab.errorLoadSaleParams') as string);
                    })
                    .finally(() => {
                        this.saveSales();
                        this.loadingConfigs = false
                    });
        }
    }

    selectInternalCodesRecomendations(): string[] {
        let result: string[] = [];
        if (this.usePromoRecommendsFilter) {
            const recommendsType = this.selectedPromoFilter;
            if (recommendsType === PromoFilterType.cd) {
                result = this.cartDrivers.map((i) => i.internalCode);
            } else if (recommendsType === PromoFilterType.ig) {
                result = this.incomeGenerators.map((i) => i.internalCode);
            } else if (recommendsType === PromoFilterType.pi) {
                result = this.trafficGenerators.map((i) => i.internalCode);
            }
        }
        return result;
    }

    recommendsListByType(): string[] {
        let result: string[] = [];
        if (this.recommendsType === PromoFilterType.cd) {
            result = this.cartDrivers.map((i) => i.internalCode);
        } else if (this.recommendsType === PromoFilterType.ig) {
            result = this.incomeGenerators.map((i) => i.internalCode);
        } else if (this.recommendsType === PromoFilterType.pi) {
            result = this.trafficGenerators.map((i) => i.internalCode);
        }
        return result;
    }

    selectData(): [number[], number[], number[], string[], string | null, Segment[] | null, string[] | null] {
        const selectSeasons: number[] = (this.$sales.seasonSelected.length === 0 || (this.$sales.seasonSelected.length === 1 && this.$sales.seasonSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$sales.seasonSelected)!!;
        const selectRegions: number[] = (!this.$sales.regionIds.length || (this.$sales.regionIds.length === 1 && this.$sales.regionIds[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$sales.regionIds)!!;

        const selectBuyerSegment: number[] = (this.$sales.buyerSegmentsList.length === 0 || (this.$sales.buyerSegmentsList.length === 1 && this.$sales.buyerSegmentsList[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$sales.buyerSegmentsList)!!;
        const selectedSku: string[] = (this.$sales.selectedSkuList.length === 0 || this.$sales.selectedSkuList.length === 1 && this.$sales.selectedSkuList[0].value === null)
                ? []
                : (this.$sales.selectedSkuList).filter((item) => item.value !== null).map((item) => {
                    return (item.value);
                });
        const ctm: string | null = this.selectCTM === 'all' ? null : this.selectCTM;
        this.selectSegmentPrice = this.selectSegmentPrice.filter((item) => {
            return item.name !== 'All'
        });
        const priceSegments: Segment[] | null = this.selectSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });
        const recommendsCodes: string[] = this.selectInternalCodesRecomendations();
        return [selectSeasons, selectRegions, selectBuyerSegment, selectedSku, ctm, priceSegments, recommendsCodes];
    }

    selectDataForRoundingRulesSeasonsRegions(): [number[], number[], number[]] {
        const selectSeasons: number[] = (this.$roundingRules.seasonSelected.length === 0 || (this.$roundingRules.seasonSelected.length === 1 && this.$roundingRules.seasonSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$roundingRules.seasonSelected)!!;
        const selectRegions: number[] = (this.$roundingRules.regionSelected.length === 0 || (this.$roundingRules.regionSelected.length && this.$roundingRules.regionSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$roundingRules.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$roundingRules.buyerSegmentsList.length === 0 || (this.$roundingRules.buyerSegmentsList.length === 1 && this.$roundingRules.buyerSegmentsList[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$roundingRules.buyerSegmentsList)!!;
        // const ctm: string | null = this.selectCTM.value === 'all' ? null : this.selectCTM.value;

        this.$log.log(selectRegions)
        return [selectSeasons, selectRegions, selectBuyerSegment];
    }

    selectDataRecommends(): [number[], number[], number[], number[]] {
        const selectSeasons: number[] = (this.$packagePromoRecommends.seasonSelected.length === 0 || (this.$packagePromoRecommends.seasonSelected.length === 1 && this.$packagePromoRecommends.seasonSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$packagePromoRecommends.seasonSelected)!!;
        const selectRegions: number[] = (this.$packagePromoRecommends.regionSelected.length === 0 || (this.$packagePromoRecommends.regionSelected.length && this.$packagePromoRecommends.regionSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$packagePromoRecommends.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$packagePromoRecommends.buyerSegmentsList.length === 0 || (this.$packagePromoRecommends.buyerSegmentsList.length && this.$packagePromoRecommends.buyerSegmentsList[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$packagePromoRecommends.buyerSegmentsList)!!;
        const selectFormats: number[] = (this.$packagePromoRecommends.formatSelected.length === 0 || (this.$packagePromoRecommends.formatSelected.length && this.$packagePromoRecommends.formatSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$packagePromoRecommends.formatSelected)!!;
        return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
    }

    getSegmentPriceInfo() {
        if (this.$sales.selectMarket.id === -1 || !this.$sales.categoryIds.length) {
            return;
        }
        const filter = this.getSkuFilter()
        this.httpGetMinMaxPriceSegment(filter)
                .then((data) => {
                    const filterData = data.data;
                    this.segmentPriceOptions = filterData.map((i) => {
                        return {value: i, label: i.name}
                    });
                })
                .catch((e) => {
                })
    }

    prepareIndividualConfig(config: SaleIndividualConfig): SaleServerIndividualConfig {
        const prepared: SaleServerIndividualConfig = {};

        if ('minPrice' in config && typeof config.minPrice !== 'undefined' && config.minPrice != null) {
            prepared.minPrice = config.minPrice;
        }

        if ('maxPrice' in config && typeof config.maxPrice !== 'undefined' && config.maxPrice != null) {
            prepared.maxPrice = config.maxPrice;
        }

        if ('minProfitability' in config && typeof config.minProfitability !== 'undefined' && config.minProfitability != null) {
            prepared.minProfitability = config.minProfitability;
        }

        if ('minDiscount' in config && typeof config.minDiscount !== 'undefined' && config.minDiscount != null) {
            prepared.minDiscount = config.minDiscount;
        }

        if ('maxDiscount' in config && typeof config.maxDiscount !== 'undefined' && config.maxDiscount != null) {
            prepared.maxDiscount = config.maxDiscount;
        }

        if ('remains' in config && typeof config.remains !== 'undefined' && config.remains != null) {
            prepared.remains = config.remains;
        }

        return prepared;
    }

    prepareCommonIndividualConfig(config: IndividualConfig): CalcIndividualConfig {
        const prepared: CalcIndividualConfig = {};

        if ('kviStrategy' in config && typeof config.kviStrategy !== 'undefined' && config.kviStrategy !== null) {
            prepared.kviStrategy = config.kviStrategy.value
        }

        if ('marginalProfit' in config && typeof config.marginalProfit !== 'undefined' && config.marginalProfit != null) {
            prepared.marginalProfit = config.marginalProfit;
        }

        if ('selectCoefficent' in config && typeof config.selectCoefficent !== 'undefined' && config.selectCoefficent !== null) {
            const coef = config.selectCoefficent;
            prepared.coefficientK1 = coef.value.k1;
            prepared.coefficientK2 = coef.value.k2;
            prepared.priceOpt = coef.value.enum;
        }

        if ('priceIncreaseLimit' in config && typeof config.priceIncreaseLimit !== 'undefined' && config.priceIncreaseLimit != null) {
            prepared.priceIncreaseLimit = config.priceIncreaseLimit;
        }

        if ('competitorsPricesParams' in config && typeof config.competitorsPricesParams !== 'undefined' && config.competitorsPricesParams != null) {
            prepared.competitorsPricesParams = config.competitorsPricesParams;
        }

        if ('percentageOfCompetitorsPrice' in config) {
            prepared.percentageOfCompetitorsPrice = config.percentageOfCompetitorsPrice;
        }

        if ('periodPriceIncreaseLimit' in config && typeof config.periodPriceIncreaseLimit !== 'undefined' && config.periodPriceIncreaseLimit != null) {
            prepared.periodPriceIncreaseLimit = config.periodPriceIncreaseLimit;
        }

        if ('period' in config && typeof config.period !== 'undefined' && config.period !== null) {
            prepared.period = config.period.value;
        }

        if ('newProductPriceStrategy' in config && typeof config.newProductPriceStrategy !== 'undefined' && config.newProductPriceStrategy !== null) {
            prepared.newProductPriceStrategy = config.newProductPriceStrategy.value;
        }

        if ('priceGap' in config && typeof config.priceGap !== 'undefined' && config.priceGap != null) {
            prepared.priceGap = config.priceGap;
        }

        return prepared;
    }

    getSalesFilter(): SalesFilters {
        const [selectSeasons, selectRegions, selectBuyerSegment, selectedSku] = this.selectData();
        const allCheck = this.$sales.allCheck;
        // const pennies = this.$sales.pennies;
        const countAtLastPurchasePrice = this.$sales.countAtLastPurchasePrice;
        const countAtFuturePurchasePrice = this.$sales.countAtFuturePurchasePrice;
        // const allNewPricesWithoutPennies = this.$sales.allNewPricesWithoutPennies;
        const allClaster = this.$sales.allClaster;
        const individualConfigsObj = Object.create(null);
        const individualCommonConfObj = Object.create(null);
// tslint:disable-next-line: forin
        for (const key in this.$sales.individualSaleConfig) {
            const value = this.$sales.individualSaleConfig[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = this.prepareIndividualConfig(value);
            }
        }

// tslint:disable-next-line: forin
        for (const key in this.$sales.individualCommonParams) {
            const value = this.$sales.individualCommonParams[key];
            if (typeof value !== 'undefined' && value != null) {
                individualCommonConfObj[key] = this.prepareCommonIndividualConfig(value);
            }
        }

        return {
            xyzChecked: this.$sales.xyzChecked,
            uvwChecked: this.$sales.uvwChecked,
            discountPrise: this.$sales.discountPrice,
            allCheck,
            // pennies,
            countAtLastPurchasePrice,
            countAtFuturePurchasePrice,
            // allNewPricesWithoutPennies,
            allClaster,
            coefficientK1: this.$sales.selectCoefficent.value.k1,
            coefficientK2: this.$sales.selectCoefficent.value.k2,
            category: null,
            storeCluster: null,
            storeClusters: this.saleToEdit.clusters.map(el => el.id).realValuesOrEmpty(),
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            spreadUVWParams: this.$sales.uvwParams,
            spreadXYZParams: this.$sales.xyzParams,
            storeRegionValues: this.saleToEdit.regions.map(el => el.id).realValuesOrEmpty(),
            groupsOfProduct: this.saleToEdit.groups.map(el => el.id).realValuesOrEmpty(),
            categories: this.saleToEdit.categories.map(el => el.id).realValuesOrEmpty(),
            storeFormat: this.saleToEdit.format.id,
            tradingId: this.saleToEdit.tradingId!,
            calculationDepth: +this.$sales.calculationDepth,
            correlation: this.$sales.correlation ? this.$sales.correlation : 0.7,
            highElasticity: this.$sales.highElasticity ? this.$sales.highElasticity : -0.5,
            intervalOfUltimateElasticity: this.$sales.intervalOfUltimateElasticity,
            competitorsPricesParams: this.$sales.competitorsPrices,
            kviStrategy: this.$sales.kviStrategy.value,
            percentageOfCompetitorsPrice: this.$sales.percentageOfCompetitorsPrice,
            marginalProfitability: this.$sales.marginalProfitability,
            marginalProfit: this.$sales.marginalProfit,
            maxMarginalProfit: this.$sales.maxMarginalProfit != null ? this.$sales.maxMarginalProfit : 100,
            marginalPriceDifference: this.$sales.marginalPriceDifference,
            calculationDay: this.periodForCalculatingEntered ? this.periodForCalculatingEntered as number : +this.$sales.calculationDay,
            priceCorridor: this.$sales.priceCorridor,
            changePriceCorridor: this.$sales.changePriceCorridor,
            priceIncreaseLimit: this.$sales.priceIncreaseLimit,
            fixLowerBorder: this.$sales.fixLowerBorder,
            individualCommonParams: individualCommonConfObj,
            depthToPurchasePrice: this.$sales.depthToPurchasePrice,
            priceFamilies: this.$sales.priceFamilies,
            hardPriceFamilies: this.$sales.hardPriceFamilies,
            // groupOfProduct: this.$sales.groupOfProduct,
            groupOfProduct: null,
// tslint:disable-next-line: no-non-null-assertion
            priceOpt: this.$sales.selectCoefficent.value.enum!,
// tslint:disable-next-line: no-non-null-assertion
            subcategories: !this.saleToEdit.subcategory || this.saleToEdit.subcategory.id == null || this.saleToEdit.subcategory.id <= 0 ? null : [this.saleToEdit.subcategory.id],
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$sales.productSegments)!!,
            useCompetitorsPrices: this.$sales.useCompetitorsPrices,
            byPromoPrices: this.$sales.byPromoPrices,
            competitorsPricePeriod: this.$sales.competitorsPricePeriod,
            competitorsCodes: this.$sales.competitorsCodes,
            competitorsPriceMethod: this.$sales.competitorsPriceMethod.value,
            competitorsPriceAdjustment: this.$sales.competitorsPriceAdjustment,
            competitorsInfluencesCoef: this.$sales.competitorsInfluencesCoef,
            competitorsMinimumProfit: this.$sales.competitorsMinimumProfit,
            competitorsMaximumProfit: this.$sales.competitorsMaximumProfit != null ? this.$sales.competitorsMaximumProfit : 100,
            competitorsControlParam: this.$sales.competitorsControlParam,
            competitorsPriceStrategy: this.$sales.competitorsPriceStrategy.value,
            // roundKviCompetitorPrice: this.$sales.roundKviCompetitorPrice,
            calculateByRegression: !this.$sales.calculateByElasticity,
            recalculateCtm: this.$sales.recalculateCtm,
            individualPromoConfigs: individualConfigsObj,
            availableStockDelta: this.$sales.availableStockDelta,
            promoInternalCodes: selectedSku,
            lift: this.$sales.lift,
            purchasePrice: this.$sales.purchasePrice,
            crossCalculation: this.$sales.crossCalculation,
            newProductLifespanInDays: this.$sales.newProductLifespanInDays,
            calculateCommon: this.$sales.calculateCommon,
            intervalOfCorrelationElasticity: this.$sales.intervalOfCorrelationElasticity,
            priceChangeLimit: this.$sales.priceChangeLimit,
            priceChangeLimitKvi: this.$sales.priceChangeLimitKvi,
            priceChangeLimitComp: this.$sales.priceChangeLimitComp,
            useBrutForcingParams: false,
            saveAfterOptimize: false,
            optimizationDiff: 0.0,
            calculatePYR: this.$sales.calculatePYR,
            periodPriceIncreaseLimit: this.$sales.periodPriceIncreaseLimit,
            period: this.$sales.period.value,
            newProductPriceStrategy: this.$sales.newProductPriceStrategy.value,
            priceGap: this.$sales.priceGap,
            priceGapCtmPc: this.$sales.priceGapCtmPc,
            findAutomaticallyPriceSegments: this.findAutomaticallyPriceSegments,
            countPriceSegments: this.countPriceSegments,
            considerPlannedSeason: this.$sales.considerPlannedSeason,
            useDiscountDurationForForecastCalculation: this.$sales.useDiscountDurationForForecastCalculation,
            useProductRange: this.$sales.useProductRange,
            useSkuRotation: this.$sales.useSkuRotation,
            promoCalc: true,
            percentageOfRecommendsKviCount: this.$sales.percentageOfRecommendsKviCount,
            saveKviSign: this.$sales.saveKviSign,
            useSegmentsPriceInSearchKVIRecParam: this.$sales.useSegmentsPriceInSearchKVIRecParam,
            categoryStrategy: this.$sales.categoryStrategy.value,
            useCompetitorsForKviRecommends: this.$sales.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: this.$sales.competitorsPeriodForKviRecommends,
            productCodesForAddKvi: this.productCodesForAddKvi,
            productCodesForDeleteKvi: this.productCodesForDeleteKvi,
            productCodesForAddCtmPurpose: this.productCodesForAddCtmPurpose,
            productCodesForDeleteCtmPurpose: this.productCodesForDeleteCtmPurpose,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            calculateCompAllowedDeviation: this.$sales.calculateCompAllowedDeviation,
            minProfitKVI: this.$sales.minProfitKVI,
            maxProfitKVI: this.$sales.maxProfitKVI != null ? this.$sales.maxProfitKVI : 100,
            productRangesAndInternalCodes: this.productRangesArray,
            // randomPennies: this.$sales.randomPennies,
            excludeOutOfStock: this.$sales.excludeOutOfStock,
            calculateBySalePoints: this.$sales.calculateBySalePoints,
            calculateBySubcategories: this.$sales.calculateBySubcategories,
            trainModel: this.$sales.trainModel,
            considerCannibalization: false,
            useCompElasticity: this.$sales.useCompElasticity,
            // manualPennies: this.$sales.manualPennies,
            forecastAccuracy: this.$sales.forecastAccuracy,
            percentileType: this.$sales.percentileType.value,
            calcWithBatchNumber: false,
            competitorPriceControlParameterPc: this.$sales.competitorPriceControlParameterPc,
            thompsonSampling: false,
            revaluationCalculateParams: this.getDefaultRevaluationCheckParams(),
            inflation: this.$sales.inflation,
            calculateBySpeedSale: this.$sales.calculateBySpeedSale,
            isFixPricePromo: this.$sales.isFixPricePromo,
            spreadByPriceSegments: this.$sales.spreadByPriceSegments,
            rotationPeriodType: this.$sales.rotationPeriodType,
            promoQuote: this.$sales.promoQuoteValue,
            promoPriceCalculationDepth: this.$sales.promoPriceCalculationDepth,
            useCompetitorsPromoPrices: this.$sales.useCompetitorsPromoPrices,
            calculateCompAllowedDeviationPromo: this.$sales.calculateCompAllowedDeviationPromo,
            competitorPriceControlParameterPcPromo: this.$sales.competitorPriceControlParameterPcPromo,
            competitorsPricePeriodPromo: this.$sales.competitorsPricePeriodPromo,
            competitorsPromoPriceInfluencesCoef: this.$sales.competitorsPromoPriceInfluencesCoef,
            percentileTypePromo: this.$sales.percentileTypePromo,
            competitorsPromoPriceAdjustment: this.$sales.competitorsPromoPriceAdjustment,
            competitorsControlPromoParam: this.$sales.competitorsControlPromoParam,
            competitorsPromoPriceMethod: this.$sales.competitorsPromoPriceMethod.value,
            competitorsMinimumProfitPromo: this.$sales.competitorsMinimumProfitPromo,
            competitorsMaximumProfitPromo: this.$sales.competitorsMaximumProfitPromo != null ? this.$sales.competitorsMaximumProfitPromo : 100,
            competitorsPromoPriceStrategy: this.$sales.competitorsPromoPriceStrategy.value,
            daysToPriceChangeStart: this.$sales.daysToPriceChangeStart && this.$sales.daysToPriceChangeStart > 0 
                ? this.$sales.daysToPriceChangeStart 
                : null,
            daysToPriceChangeFinish: this.$sales.daysToPriceChangeFinish && this.$sales.daysToPriceChangeFinish > 0 
                ? this.$sales.daysToPriceChangeFinish 
                : null,
            planningPromoPeriodStartDate:
                !!this.saleToEdit.startDate
                    ? moment.utc(this.saleToEdit.startDate).startOf('day').valueOf()
                    : null,
            planningPromoPeriodEndDate:
                !!this.saleToEdit.endDate
                    ? moment.utc(this.saleToEdit.endDate).startOf('day').valueOf()
                    : null,
            minDefaultDiscount: this.saleToEdit.minSaleDiscount || 0,
            maxDefaultDiscount: this.saleToEdit.maxSaleDiscount || 0,
            priceDecreaseLimit: this.$sales.priceDecreaseLimit,
            minPromoPrice: this.$sales.minPromoPrice,
            autoCreateSchedule: !!this.$sales.autoCreateSchedule,
        };
    }

    get priceDecreaseLimitValidate(): boolean {
        const priceDecreaseLimit = this.$sales.priceDecreaseLimit;
        return priceDecreaseLimit != null && priceDecreaseLimit.toString() !== '' && priceDecreaseLimit >= 0;
    }

    getPackagePromoRecommendsFilter(): PackagePromoConfig {
        const [selectSeasons, selectRegions, selectBuyerSegment, selectFormats] = this.selectDataRecommends();
        const selectClusters: number[] = (this.$packagePromoRecommends.clusterSelected.length === 0 || (this.$packagePromoRecommends.clusterSelected.length && this.$packagePromoRecommends.clusterSelected[0] === 0))
                // tslint:disable-next-line: no-non-null-assertion
                ? [] : LocalData.filterNumberArrays(this.$packagePromoRecommends.clusterSelected)!!;
        return {
            tradingId: this.$packagePromoRecommends.selectMarket.id,
// tslint:disable-next-line: no-non-null-assertion
            categories: LocalData.filterNumberArrays(this.$packagePromoRecommends.categoriesOfProduct)!!,
            productSegments: LocalData.filterNumberArrays(this.$packagePromoRecommends.productSegments)!!,
            storeCluster: selectClusters,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            storeFormat: selectFormats,
// tslint:disable-next-line: no-non-null-assertion
            groupsOfProduct: LocalData.filterNumberArrays(this.$packagePromoRecommends.groupsOfProduct)!!,
// tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$packagePromoRecommends.subcategories),
            separateSubcategories: this.$packagePromoRecommends.separateSubcategories,
            separateClusters: this.$packagePromoRecommends.separateClusters,
            categoryStrategy: this.$packagePromoRecommends.categoryStrategy.value,
            calculationDepth: this.$packagePromoRecommends.calculationDepth,
            calculationDay: this.$packagePromoRecommends.calculationDay,
            manualPennies: this.$packagePromoRecommends.manualPennies,
            calcWithBatchNumber: false,
            thompsonSampling: false,
            applyOmnichannel: false,
            sendGeneralReportNotification: localStorage.getItem('sendGeneratedReportNotification') === 'true',
            isFixPricePromo: this.$packagePromoRecommends.isFixPricePromo,
            useSkuRotation: this.$sales.useSkuRotation,
            useFixedPrices: true,
        };
    }

    getSkuFilter(): SkuFilter & { storeClusters: number[] } {
      const productSegments = this.selectProductSegmentIdAndName.map((i) => i.segmentId).filter((it) => it !== null) as number[];

      const [selectSeasons, selectRegions, selectBuyerSegment, selectedSku, ctm, priceSegments] = this.selectData();

      return {
            category: null,
            storeCluster: null,
            storeClusters: this.$sales.clusterIds.realValuesOrEmpty(),
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: this.$sales.groupIds,
            categories: this.$sales.categoryIds,
            storeFormat: this.$sales.formatSelected,
            tradingId: this.$sales.selectMarket.id,
            calculationDepth: this.$sales.calculationDepth,
            calculationDay: this.periodForCalculatingEntered ? this.periodForCalculatingEntered as number : +this.$sales.calculationDay,
            skuFilter: this.skuFilter,
            promoFilter: this.selectedPromoFilter,
            intervalOfUltimateElasticity: this.$sales.intervalOfUltimateElasticity,
            groupOfProduct: null,
// tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$sales.subcategories)!!,
            discountPrise: false,
            promo: true,
            sortBySKU: this.sortBySKU,
            kvi: this.selectKVI,
            ctm,
            priceSegments,
            priceCorridor: this.$sales.priceCorridor,
            changePriceCorridor: this.$sales.changePriceCorridor,
            productsFilter: this.selectProducts,
            internalCodes: selectedSku,
            needCalculateSku: this.skuListWithCalculating,
            needCalculateSkuLastPricesOnly: this.needCalculateSkuLastPricesOnly,
            needCalculateSkuActualProfitabilityOnly: this.needCalculateSkuActualProfitabilityOnly,
            kviRecommendation: this.selectKVIRecommends,
            productSegments,
            keyCharacteristicOfTheProductIsOne: this.selectKeyCharacteristicOne,
            keyCharacteristicOfTheProductIsTwo: this.selectKeyCharacteristicTwo,
            recipeAttributes: this.selectRecipeAttributes,
            treatmentAttributes: this.selectTreatmentAttributes,
            alwaysCalculateProductSegments: true,
            countAtLastPurchasePrice: this.$sales.countAtLastPurchasePrice,
            productRangeFilter: this.selectProductLine,
            correlation: this.$sales.correlation,
        };
    }

    isValidDate(dateString: string, format: string = "YYYY-MM-DD") {
        return moment(dateString, format, true).isValid()
    }

    isValidPlanningPromoPeriod(): boolean {
        if (!this.isValidDate(this.saleToEdit.startDate as string)
            || !this.isValidDate(this.saleToEdit.endDate as string)
        ) {
            return false
        }

        const now = moment(new Date())
        const startDate = moment(this.saleToEdit.startDate as string)
        const endDate = moment(this.saleToEdit.endDate as string)

        // if (startDate.isBefore(now, 'days') || endDate.isBefore(startDate, 'days')) {
        return !endDate.isBefore(startDate, 'days');
    }

    async preCalc() {
        if (!this.isValidPlanningPromoPeriod()) {
          this.showError(this.$t('shared.parametersTab.invalidPlanPeriod') as string)
          return;
        }

        this.isCalculationButtonLoading = true;

        this.saveSales();

        if (this.isNeedSaveParamsBeforeStartCalc) {
            await this.saveParams();
        }

        const data = this.getSalesFilter();

        this.httpPackageSalesCalculationStart({
            ...data,
            saleId: this.saleToEdit.id,
            saleName: this.saleToEdit.name,
            minProfitability: this.saleToEdit.minMargin,
            maxProfitability: this.$sales.maxMarginalProfit != null ? this.$sales.maxMarginalProfit : 100,
            minDiscount: this.saleToEdit.minSaleDiscount,
            maxDiscount: this.saleToEdit.maxSaleDiscount,
            stagesNumber: this.saleToEdit.stagesNumber,
            startDate: !!this.saleToEdit.startDate
                ? moment.utc(this.saleToEdit.startDate).startOf('day').valueOf()
                : null,
            endDate: !!this.saleToEdit.endDate
                ? moment.utc(this.saleToEdit.endDate).startOf('day').valueOf()
                : null,
          stageNumber: this.saleToEdit.stagesNumber,
          minMargin: this.saleToEdit.minMargin,

        } as SalesCalculationFilters)
            .then((r) => {
                    this.showInfo(this.$t('shared.parametersTab.calcStartedForSale', { name: this.currentSale.name }) as string);
                    this.$log.debug('Create task', r.data);
                },
            )
            .catch(() => {
                this.showError(this.$t('shared.parametersTab.errorStartCalcForSale', { name: this.currentSale.name }) as string);
            }).finally(() => {
                this.isCalculationButtonLoading = false;
            });
    }

    calcWithoutPromo() {
        const data = this.getSalesFilter();
        this.saveSales();
        if (!data.calculateCommon) {
            this.recalculatingRegularPricesModalShow = true
        } else {
            this.httpGetCalcPromo(data)
                    .then((r) => {
                                this.showInfo(this.$t('shared.parametersTab.calcStarted') as string);
                                this.$log.debug('Create task', r.data);
                            },
                    )
                    .catch((ex) => {
                        this.showError(this.$t('shared.parametersTab.errorStartCalc') as string);
                    });
        }
    }

    calcWithRegularPrices() {
        const data = this.getSalesFilter();
        this.saveSales();
        data.calculateCommon = true;
        this.httpGetCalcPromo(data)
                .then((r) => {
                            this.showInfo(this.$t('shared.parametersTab.calcStarted') as string);
                            this.$log.debug('Create task', r.data);
                        },
                )
                .catch((ex) => {
                    this.showError(this.$t('shared.parametersTab.errorStartCalc') as string);
                });
    }

    calcWithoutRegularPrices() {
        const data = this.getSalesFilter();
        this.saveSales();
        this.httpGetCalcPromo(data)
                .then((r) => {
                            this.showInfo(this.$t('shared.parametersTab.calcStarted') as string);
                            this.$log.debug('Create task', r.data);
                        },
                )
                .catch((ex) => {
                    this.showError(this.$t('shared.parametersTab.errorStartCalc') as string);
                });
    }

    async saveParams() {
        await this.updateBasicSaleParams();

        if (!this.isValidPlanningPromoPeriod()) {
          this.showError(this.$t('shared.parametersTab.invalidPlanPeriod') as string)
          return;
        }

        // Подгружаем конкурентов перед сохранением, на случай если забыли подгрузить через открытие списка SKU
        if (this.$sales.competitorsCodes.length === 0) {
            const competitorFilter = this.getCompetitorsFilter();
            await this.httpLoadCompetitors(competitorFilter, -1, 0)
                    .then((data) => {
                        this.competitors = data.data;
                        this.$sales.competitorsCodes = this.competitors.map((i) => {
                            return i.internalCode;
                        });
                    })
                    .catch((e) => {
                        this.showError(this.$t('shared.parametersTab.errorLoadCompetitorPrices') as string);
                    });
        }

        const filters: SalesCalculationFilters = {
            ...this.getSalesFilter(),
            saleId: this.saleToEdit.id,
            saleName: this.saleToEdit.name,
            minProfitability: this.saleToEdit.minMargin,
            maxProfitability: 100, // по умолчанию, т.к. неоткуда взять, maxMargin поля нет
            minDiscount: this.saleToEdit.minSaleDiscount,
            maxDiscount: this.saleToEdit.maxSaleDiscount,
            stagesNumber: this.saleToEdit.stagesNumber,
            startDate: !!this.saleToEdit.startDate
                ? moment.utc(this.saleToEdit.startDate).startOf('day').valueOf()
                : null,
            endDate: !!this.saleToEdit.endDate
                ? moment.utc(this.saleToEdit.endDate).startOf('day').valueOf()
                : null,
            stageNumber: this.saleToEdit.stagesNumber,
            minMargin: this.saleToEdit.minMargin,
        };

        await this.httpSaveSalesFilter(filters)
                .then((r) => {
                    this.$log.debug('Параметры сохранены', r.data);
                    this.showInfo(this.$t('shared.parametersTab.saveParamsSuccess') as string);

                    if (this.isNeedSaveParamsBeforeStartCalc) {
                        this.isNeedSaveParamsBeforeStartCalc = false;
                    }
                })
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorSaveCalcParams') as string);
                });
    }

    getCompetitorsFilter(): CompetitorsPriceFilter {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        return {
            discountPrise: this.$sales.discountPrice,
            category: null,
            storeCluster: null,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: this.$sales.groupIds,
            categories: this.$sales.categoryIds,
            storeFormat: this.$sales.formatSelected,
            tradingId: this.$sales.selectMarket.id,
            calculationDepth: +this.$sales.calculationDepth,
            calculationDay: this.periodForCalculatingEntered ? this.periodForCalculatingEntered as number : +this.$sales.calculationDay,
            skuFilter: this.skuFilter,
            groupOfProduct: null,
// tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$sales.subcategories)!!,
            productSegments: LocalData.filterNumberArrays(this.$sales.productSegments)!!,
            competitorsPricePeriod: this.$sales.competitorsPricePeriod,
            promo: true,
            sortingField: null,
            isKviCartCompetitorsGrid: false,
        };
    }

    updatePriceCorridorAndSkuList() {
        this.priceCorridorInfo();
        this.saveSales();
        this.saveCalc();
    }

    reloadSkuList() {
        this.isFiltersChanged = 1;
        this.needLoadSkuList = false;
    }

    clearFilters() {
        this.sortBySKU = -1;
        this.selectKVI = this.defaultFilterValue.value;
        this.selectKVIRecommends = this.defaultFilterValue.value;
        this.selectCTM = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
        this.selectSegmentPrice = [];
        this.selectProducts = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string}.value;
        this.selectedPromoFilter = {value: PromoFilterType.all, label: this.$t('shared.selectBox.all') as string}.value;
        this.segmentPriceOptions = [];
        this.selectProductSegmentIdAndName = [];
        this.productSegmentIdAndNameOptions = [];
        this.selectKeyCharacteristicOne = [];
        this.selectKeyCharacteristicTwo = [];
        this.selectRecipeAttributes = [];
        this.selectTreatmentAttributes = [];
        this.selectProductLine = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
    }

    clearFiltersInNewProductsTable() {
        this.sortingNewProductsBySKU = -1;
        this.selectKVIForNewProducts = this.defaultFilterValue.value;
        this.selectCTMForNewProducts = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
        this.selectSegmentPriceForNewProducts = [];
        this.segmentPriceOptionsForNewProducts = [];
        this.selectNewProductSegmentIdAndName = [];
        this.newProductSegmentIdAndNameOptions = [];
        this.selectKeyCharacteristicOneForNewProduct = [];
        this.selectKeyCharacteristicTwoForNewProduct = [];
        this.selectRecipeAttributesForNewProduct = [];
        this.selectTreatmentAttributesForNewProduct = [];
        this.refreshNewProductsTable()
    }

    calcButtonState(): boolean {
        if (this.$sales.selectMarket != null) {
            const state = this.purchasePricePositive &&
                    this.calculationDepthValidate &&
                    this.calculationDayValidate &&
                    this.priceIncreaseLimitValidate &&
                    this.marginalPriceDifferenceValidate &&
                    this.marginalProfitabilityValidate &&
                    this.marginalProfitValidate &&
                    this.inputInterval &&
                    this.liftPositiveCheck &&
                    this.correlationCheck && this.competitorPriceControlParameterPcValidate;
            return !state;
        }
        return true;
    }

    calcButtonStateForSearchRecommends(): boolean {
        if (this.$packagePromoRecommends.selectMarket != null) {
            const state = this.isGroupsRecommendsSelected;
            return !state;
        }
        return true;
    }

    refreshPriceSegments() {
        if (!this.findAutomaticallyPriceSegments) {
            this.countPriceSegments = 1;
        }
    }

    hideSkuPanel() {
        this.showSku = false;
        this.clearFilters();
    }

    setCalcIndividConfig(config: ConfigMap<IndividualConfig>, sku: string, property: keyof IndividualConfig, value: number | SelectBox<any> | string) {
        if (!(sku in config)) {
            config[sku] = {};
        }
        config[sku][property] = value;
    }

    setPromoIndividConfig(config: ConfigMap<PromoIndividualConfig>, sku: string, property: keyof PromoIndividualConfig, value: number | SelectBox<any>) {
        if (!(sku in config)) {
            config[sku] = {};
        }
        if (typeof value === 'number' && Number.isNaN(value)) {
            config[sku][property] = null;
        } else {
            config[sku][property] = value;
        }
    }

    calcRegularPricesProfitability() {
        if (this.$sales.selectMarket.id === -1 || !this.$sales.categoryIds.length || this.regularPricesProfitability != null) {
            return;
        }
        this.isRegularPricesProfitabilityCalculated = true;
        if (this.showSku) {
            this.showSku = false
        }

        const filter = this.getSkuFilter();

        this.httpGetRegularPricesProfitability(filter)
                .then((number) => {
                    this.regularPricesProfitability = number.data;
                    this.isRegularPricesProfitabilityCalculated = false;
                })
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorCalcProfitability') as string);
                    this.isRegularPricesProfitabilityCalculated = false;
                });
    }

    calcActualProfitability() {
        if (this.$sales.selectMarket.id === -1 || !this.$sales.categoryIds.length || this.actualProfitability != null) {
            return;
        }
        this.isActualProfitabilityCalculated = true;
        if (this.showSku) {
            this.showSku = false
        }

        const filter = this.getSkuFilter()
        this.httpGetActualProfitability(filter)
                .then((number) => {
                    this.actualProfitability = number.data;
                    this.isActualProfitabilityCalculated = false;
                })
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorCalcActualProfitability') as string);
                    this.isActualProfitabilityCalculated = false;
                })
    }

    onTabsChanged(evt: string) {
        if (evt === "systemTab") {
            (this.$refs.competitorsListRef as any).activate();
        } else {
            (this.$refs.competitorsListRef as any).deactivate();
        }
    }

    private priceCorridorInfo() {
        if (!this.$sales.changePriceCorridor) {
            this.hideSkuPanel();
            return;
        }
        if (this.$sales.selectMarket.id === -1 || !this.$sales.categoryIds.length) {
            return;
        }
        this.isPriceCorridorCalculated = true;

        const filters = this.getSalesFilter();
        this.httpPostPriceCorridor(filters)
                .then((r) => {
                            this.$sales.priceCorridor = r.data;
                            this.isPriceCorridorCalculated = false;
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorLoadPriceCorridor') as string);
                    this.$log.error('Error occurred [load price corridor]', e);
                    this.isPriceCorridorCalculated = false;
                });
    }

    private refreshNewProductsTable() {
        const oldRefreshId = this.refreshNewProductsListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshNewProductsListId === timeoutId) {
                this.newProductsPagination.current = 1;
                const newProductsTableInPanel = this.$refs.newProductsTableRef as any;
                if (typeof newProductsTableInPanel !== 'undefined') {
                    newProductsTableInPanel.refresh();
                }
                this.refreshNewProductsListId = -1;
            }
        }, 250);
        this.refreshNewProductsListId = timeoutId;
    }

    private refreshCdRecommends() {
        this.selectProductsTypeForRecommends = this.selectProductsForCdRecommends.value;
        this.kviValueForRecommends = this.selectKVIForCdRecommends.value;
        this.ctmValueForRecommends = this.selectCTMForCdRecommends.value === 'all' ? null : this.selectCTMForCdRecommends.value;
        this.sortBySKUValueForRecommends = this.sortBySKUForCdRecommends;
        this.segmentPriceValueForRecommends = this.selectCdRecommendsSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });
        this.refreshCdRecommendsTable();
    }

    private refreshIgRecommends() {
        this.selectProductsTypeForRecommends = this.selectProductsForIgRecommends.value;
        this.kviValueForRecommends = this.selectKVIForIgRecommends.value;
        this.ctmValueForRecommends = this.selectCTMForIgRecommends.value === 'all' ? null : this.selectCTMForIgRecommends.value;
        this.sortBySKUValueForRecommends = this.sortBySKUForIgRecommends;
        this.segmentPriceValueForRecommends = this.selectIgRecommendsSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });
        this.refreshIgRecommendsTable();
    }

    private refreshCdRecommendsTable() {
        const oldRefreshId = this.refreshCdRecommendsId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshCdRecommendsId === timeoutId) {
                this.skuRecommendsListCurrentPage = 1;
                const recommendsCdSKU = this.$refs.recommendsCdSKU as any;
                if (typeof recommendsCdSKU !== 'undefined') {
                    recommendsCdSKU.refresh();
                }
                this.refreshCdRecommendsId = -1;
            }
        }, 250);
        this.refreshCdRecommendsId = timeoutId;
        this.isFiltersChangedForRecommends = 1;
    }

    private refreshIgRecommendsTable() {
        const oldRefreshId = this.refreshIgRecommendsId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshIgRecommendsId === timeoutId) {
                this.skuRecommendsListCurrentPage = 1;
                const recommendsIgSKU = this.$refs.recommendsIgSKU as any;
                if (typeof recommendsIgSKU !== 'undefined') {
                    recommendsIgSKU.refresh();
                }
                this.refreshIgRecommendsId = -1;
            }
        }, 250);
        this.refreshIgRecommendsId = timeoutId;
        this.isFiltersChangedForRecommends = 1;
    }

    private refreshPromoSkuList() {
        this.trafficGenerators = [];
        this.incomeGenerators = [];
        this.cartDrivers = [];
    }

    private loadCommonParams(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpFindSalesParams, findFilterParams)
                    .then((r) => {
                        if (!r.ignore) {
                            const resp = r.response;
                            if (resp.status === 200) {
                                const filter = resp.data.filters;

                                this.applySalesFilters(this.$sales as any, filter);
                            } else if (resp.status === 204) {
                                this.isNeedSaveParamsBeforeStartCalc = true;
                            }
                        }
                        resolve(!r.ignore);
                    })
                    .catch((e) => {
                        reject(e)
                    })
        });
    }

    private loadSalesParams(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpFindSalesParams, findFilterParams)
                    .then((r) => {
                        if (!r.ignore) {
                            const resp = r.response;
                            if (resp.status === 200) {
                                const filter = resp.data.filters;
                                this.applyPromoFilters(this.$sales as any, filter);
                            }
                        }
                        resolve(!r.ignore)
                    })
                    .catch((e) => {
                        reject(e);
                    });
        });
    }

    private loadCommonIndividual(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpLoadBaseIndividual, findFilterParams)
                    .then((r) => {
                        if (!r.ignore) {
                            const resp = r.response;
                            if (resp.status === 200) {
                                const params = resp.data;
                                this.applyBaseIndividualConfig(this.$sales as any, params);
                            }
                        }
                        resolve(!r.ignore);
                    })
                    .catch((e) => reject(e))
        });
    }

    private loaSalesIndividual(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpLoadSalesIndividual, findFilterParams)
                    .then((r) => {
                        if (!r.ignore) {
                            const resp = r.response;
                            if (resp.status === 200) {
                                const params = resp.data;
                                this.applySalesIndividualConfig(this.$sales as any, params);
                            }
                        }
                        resolve(!r.ignore)
                    })
                    .catch((e) => reject(e));
        })
    }

    get calcButt(): boolean {
        return this.calcButtonState();
    }

    get calcButtRecommends(): boolean {
        return this.calcButtonStateForSearchRecommends();
    }

    get purchasePricePositive(): boolean {
        return this.$sales.purchasePrice == null || this.$sales.purchasePrice > 0;
    }

    get calculationDepthValidate(): boolean {
        return this.$sales.calculationDepth * 7 >= this.$sales.calculationDay;
    }

    get promoPriceCalculationDepthValidate(): boolean {
      return this.$sales.calculationDepth * 7 >= this.$sales.calculationDay;
    }

    get promoRecommendsCalculationDepthValidate(): boolean {
        return this.$packagePromoRecommends.calculationDepth * 7 >= this.$packagePromoRecommends.calculationDay;
    }

    get calculationDayValidate(): boolean {
        return this.$sales.calculationDay > 0;
    }

    get promoRecommendsCalculationDayValidate(): boolean {
        return this.$packagePromoRecommends.calculationDay > 0;
    }

    get priceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.$sales.priceIncreaseLimit;
        return priceIncreaseLimit.toString() !== '' && priceIncreaseLimit >= 0;

    }

    get marginalPriceDifferenceValidate(): boolean {
        if (this.$sales.marginalPriceDifference != null) {
            return this.$sales.marginalPriceDifference >= 0 && this.$sales.marginalPriceDifference <= 100;
        }
        return false;
    }

    get marginalProfitabilityValidate(): boolean {
        const marginalProfitability = this.$sales.marginalProfitability;
        if (marginalProfitability < 0) {
            this.marginalSkuErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
        } else {
            this.marginalSkuErrorText = ''
        }
        return marginalProfitability < 100;
    }

    get competitorsMinProfitValidate(): boolean {
        const competitorsMinimumProfit = this.$sales.competitorsMinimumProfit;
        return competitorsMinimumProfit.toString() !== '' && competitorsMinimumProfit >= -50 && competitorsMinimumProfit <= 500;
    }

    get competitorsMinProfitPromoValidate(): boolean {
      const competitorsMinimumProfitPromo = this.$sales.competitorsMinimumProfitPromo;
      return competitorsMinimumProfitPromo.toString() !== '' && competitorsMinimumProfitPromo >= -50 && competitorsMinimumProfitPromo <= 500;
    }

    get competitorsMaximumProfitPromoValidate(): boolean {
        const competitorsMaximumProfitPromo = this.$sales.competitorsMaximumProfitPromo != null ? this.$sales.competitorsMaximumProfitPromo : 100;
        const competitorsMinimumProfitPromo = this.$sales.competitorsMinimumProfitPromo != null ? this.$sales.competitorsMinimumProfitPromo : 0;
        if (competitorsMaximumProfitPromo < competitorsMinimumProfitPromo) {
            this.competitorsMaximumProfitPromoErrorText = this.$t('shared.parametersTab.maxProfitMustBeGteMin') as string
        } else if (competitorsMaximumProfitPromo > 100) {
            this.competitorsMaximumProfitPromoErrorText = this.$t('shared.parametersTab.maxProfitMustBeLte100') as string
        } else {
            this.competitorsMaximumProfitPromoErrorText = ''
        }
        return competitorsMaximumProfitPromo >= competitorsMinimumProfitPromo && competitorsMaximumProfitPromo <= 100;
    }

    get priceGapValidate(): boolean {
        const priceGap = this.$sales.priceGap;
        return priceGap.toString() !== '' && priceGap >= 0;
    }

    get priceGapCtmPcValidate(): boolean {
        const priceGapCtm = this.$sales.priceGapCtmPc;
        return priceGapCtm !== null && priceGapCtm.toString() !== '' && priceGapCtm >= 0 && priceGapCtm <= 100;
    }

    get minProfitKVIValidate(): boolean {
        const minProfitKvi = this.$sales.minProfitKVI;
        return minProfitKvi.toString() !== '' && minProfitKvi >= -50 && minProfitKvi <= 500;
    }

    get marginalProfitValidate(): boolean {
        const marginalProfit = this.$sales.marginalProfit;
        if (marginalProfit < 0) {
            this.marginalErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
        } else {
            this.marginalErrorText = ''
        }
        return marginalProfit.toString() !== '' && marginalProfit < 100;
    }

    get maxMarginalProfitValidate(): boolean {
        const maxMarginalProfit = this.$sales.maxMarginalProfit != null ? this.$sales.maxMarginalProfit : 100;
        const marginalProfit = this.$sales.marginalProfit != null ? this.$sales.marginalProfit : 0;
        if (maxMarginalProfit < marginalProfit) {
            this.maxMarginalErrorText = this.$t('shared.parametersTab.maxProfitMustBeGteMin') as string
        } else if (maxMarginalProfit > 100) {
            this.maxMarginalErrorText = this.$t('shared.parametersTab.maxProfitMustBeLte100') as string
        } else {
            this.maxMarginalErrorText = ''
        }
        return maxMarginalProfit >= marginalProfit && maxMarginalProfit <= 100;
    }

    get minPromoPriceValidate(): boolean {
        const minPromoPrice = this.$sales.minPromoPrice;
        return (!minPromoPrice && minPromoPrice !== 0) || minPromoPrice > 0;
    }

    get globalIndividualMarginalProfitValidate(): boolean {
        const marginalProfit = this.globalIndividualMarginalProfitability;
        if (marginalProfit !== null) {
            if (marginalProfit < 0) {
                this.globalIndividualMarginalErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
            } else {
                this.globalIndividualMarginalErrorText = ''
            }
            this.globalIndividualMarginalBlockButton = marginalProfit > 100;
            return marginalProfit < 100;
        }
        return true;
    }

    get globalNewProductIndividualMarginalProfitValidate(): boolean {
        const marginalProfit = this.globalIndividualNewProductMarginalProfitability;
        if (marginalProfit !== null) {
            if (marginalProfit < 0) {
                this.globalNewProductIndividualMarginalErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
            } else {
                this.globalNewProductIndividualMarginalErrorText = ''
            }
            this.globalNewProductIndividualMarginalBlockButton = marginalProfit > 100;
            return marginalProfit < 100;
        }
        return true;
    }

    get globalIndividualPeriodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.globalIndividualPeriodPriceIncreaseLimit;
        if (periodPriceIncreaseLimit == null) {
            return true;
        } else {
            this.globalIndividualPeriodPriceIncreaseLimitBlockButton = periodPriceIncreaseLimit < 0;
            return periodPriceIncreaseLimit >= 0;
        }
    }

    get globalIndividualPriceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.globalIndividualPriceIncreaseLimit;
        if (priceIncreaseLimit == null) {
            return true;
        } else {
            this.globalIndividualPriceIncreaseLimitBlockButton = priceIncreaseLimit < 0 || priceIncreaseLimit > 100;
            return priceIncreaseLimit >= 0 && priceIncreaseLimit < 100;
        }
    }

    get priceChangeLimitValidate(): boolean {
        const priceChangeLimit = this.$sales.priceChangeLimit;
        return priceChangeLimit >= 0 && priceChangeLimit < 100;
    }

    get countPriceSegmentsValidate(): boolean {
        const countSegments = this.countPriceSegments;
        return countSegments.toString() !== '' && countSegments > 0;
    }

    get promoQuoteValidate(): boolean {
        const promoQuoteValue = this.$sales.promoQuoteValue;
        return promoQuoteValue != null && promoQuoteValue > 0;
    }

    get periodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.$sales.periodPriceIncreaseLimit;
        return periodPriceIncreaseLimit.toString() !== '' && periodPriceIncreaseLimit >= 0;
    }

    get inputInterval(): boolean {
        const lowerI = this.$sales.intervalOfUltimateElasticity.lower.toString();
        const upperI = this.$sales.intervalOfUltimateElasticity.upper.toString();
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get inputIntervalCorrelation(): boolean {
        const lowerI = this.$sales.intervalOfCorrelationElasticity.lower.toString();
        const upperI = this.$sales.intervalOfCorrelationElasticity.upper.toString();
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get inputIntervalP(): boolean {
        if (this.$sales.selectMarket.id === -1 || !this.$sales.categoryIds.length) {
            return false;
        }
        const lowerI = this.$sales.priceCorridor.min.toString();
        const upperI = this.$sales.priceCorridor.max.toString();
        if (this.$sales.priceCorridor.min >= this.$sales.priceCorridor.max || this.$sales.priceCorridor.min >= this.$sales.priceCorridor.max) {
            return false;
        }
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }

        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get liftPositiveCheck(): boolean {
        return this.$sales.lift >= 0;
    }

    get globalLiftPositiveCheck(): boolean {
        if (this.globalIndividualLift !== null) {
            this.globalLiftBlockButton = this.globalIndividualLift < 0 || this.globalIndividualLift > 100;
            return this.globalIndividualLift >= 0 && this.globalIndividualLift <= 100;
        }
        return true;
    }

    get globalNewProductLiftPositiveCheck(): boolean {
        if (this.globalIndividualNewProductLift !== null) {
            this.globalNewProductLiftBlockButton = this.globalIndividualNewProductLift < 0 || this.globalIndividualNewProductLift > 100;
            return this.globalIndividualNewProductLift >= 0 && this.globalIndividualNewProductLift <= 100;
        }
        return true;
    }

    get highElasticityCheck(): boolean {
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        const highElasticity = this.$sales.highElasticity.toString();
        this.$log.debug(highElasticity.length > 0, numberPattern.test(highElasticity));
        return numberPattern.test(highElasticity);
    }

    get correlationCheck(): boolean {
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        const correlation = this.$sales.correlation.toString();
        if (correlation.length === 0 || !numberPattern.test(correlation)) {
            return false;
        }
        const cor = parseFloat(correlation);
        return 1 >= cor && cor >= -1;
    }

    get isDisabledPriceBorder(): boolean {
        return !this.$sales.changePriceCorridor;
    }

    get paramsSumXYZ(): boolean {
        const x = this.$sales.xyzParams.x;
        const y = this.$sales.xyzParams.y;
        const z = this.$sales.xyzParams.z;
        if (x.toString().length === 0 || y.toString().length === 0 || z.toString().length === 0) {
            return false;
        }
        const sum = (x + y + z);
        return sum === 100;
    }

    get paramsSum(): boolean {
        const u = this.$sales.uvwParams.u;
        const v = this.$sales.uvwParams.v;
        const w = this.$sales.uvwParams.w;
        if (u.toString().length === 0 || v.toString().length === 0 || w.toString().length === 0) {
            return false;
        }
        const sum = (+v + +u + +w);
        return sum === 100;
    }

    get competitorsPricesValidate(): boolean {
        const competitorsP = this.$sales.competitorsPrices.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);

        return numberPattern.test(competitorsP);
    }

    get percentageOfRecommendsKviValidate(): boolean {
        const kviRecommends = this.$sales.percentageOfRecommendsKviCount.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);
        return numberPattern.test(kviRecommends);
    }

    get isSubcategorySelected(): boolean {
        const subcategories = LocalData.filterNumberArrays(this.$sales.subcategories);
        return subcategories != null && subcategories.length!! > 0;
    }

    get isSubcategorySelectedRecommends(): boolean {
        const subcategories = LocalData.filterNumberArrays(this.$packagePromoRecommends.subcategories);
        return subcategories != null && subcategories.length!! > 0;
    }


    get isSubcategorySelectedForRoundingRules(): boolean {
        const subcategories = LocalData.filterNumberArrays(this.$roundingRules.subcategories);
        return subcategories != null && subcategories.length!! > 0;
    }

    get isGroupSelected(): boolean {
// tslint:disable-next-line: no-non-null-assertion
        return !!this.$sales.groupIds.length;
    }

    get isGroupSelectedForRoundingRules(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$roundingRules.groupOfProduct != null && this.$roundingRules.groupOfProduct!! > 0;
    }

    get isGroupsRecommendsSelected(): boolean {
        const groups = LocalData.filterNumberArrays(this.$packagePromoRecommends.groupsOfProduct);
        return groups != null && groups.length > 0;
    }

    get competitorPriceControlParameterPcValidate(): boolean {
        return this.$sales.competitorPriceControlParameterPc.toString() !== '' && this.$sales.competitorPriceControlParameterPc > 0 && this.$sales.competitorPriceControlParameterPc <= 100;
    }

    get daysToPriceChangeStartValidateSales(): boolean | null {
        if (this.$sales.daysToPriceChangeStart == null || this.$sales.daysToPriceChangeStart === 0) {
            return null;
        }
        return this.$sales.daysToPriceChangeStart > 0;
    }

    get daysToPriceChangeFinishValidateSales(): boolean | null {
        if (this.$sales.daysToPriceChangeFinish == null || this.$sales.daysToPriceChangeFinish === 0) {
            return null;
        }
        if (this.$sales.daysToPriceChangeFinish <= 0) {
            return false;
        }
        if (this.$sales.daysToPriceChangeStart != null && this.$sales.daysToPriceChangeStart > 0) {
            return this.$sales.daysToPriceChangeFinish >= this.$sales.daysToPriceChangeStart;
        }
        return true;
    }

    setNonNegativeInteger(input: string): string {
        const parsed = parseInt(input, 10);
        if (isNaN(parsed)) {
            return input;
        }
        if (parsed < 0) {
            return '0';
        }
        return parsed.toString();
    }

    get competitorPriceControlParameterPcPromoValidate(): boolean {
      return this.$sales.competitorPriceControlParameterPcPromo.toString() !== ''
          && this.$sales.competitorPriceControlParameterPcPromo > 0
          && this.$sales.competitorPriceControlParameterPcPromo <= 100;
    }

    get minMarginValidate(): boolean {
        return !!((this.saleToEdit.minMargin || this.saleToEdit.minMargin === 0) && this.saleToEdit.minMargin >= -100 && this.saleToEdit.minMargin <= 100);
    }

    get minSaleDiscountValidate(): boolean {
        return !!((this.saleToEdit.minSaleDiscount || this.saleToEdit.minSaleDiscount === 0) && this.saleToEdit.minSaleDiscount >= 0 && this.saleToEdit.minSaleDiscount <= 100);
    }

    get maxSaleDiscountValidate(): boolean {
        return !!((this.saleToEdit.maxSaleDiscount || this.saleToEdit.maxSaleDiscount === 0) && this.saleToEdit.maxSaleDiscount >= 0 && this.saleToEdit.maxSaleDiscount <= 100);
    }

    private get isGroupsSelected(): boolean {
        return !!(this.entityFilters.groupIds.length && this.entityFilters.groupIds[0] !== 0);
    }

    private get isCategoriesSelected(): boolean {
        return !!(this.entityFilters.categoryIds.length && this.entityFilters.categoryIds[0] !== 0);
    }

    private get isFormatSelected(): boolean {
        return !!this.entityFilters.formatId;
    }

    private get isRegionsSelected(): boolean {
        return !!(this.entityFilters.regionIds.length && this.entityFilters.regionIds[0] !== 0);
    }

    private get isRequiredFiltersNotSelected(): boolean {
        return !this.isGroupsSelected || !this.isFormatSelected;
    }

    private returnToSalesList() {
        this.$emit('to-sales-list');
    }

    private setNonNegative(input: string): string {
        const parsed = parseFloat(input);
        if (isNaN(parsed)) {
            return input;
        }
        if (parsed < 0) {
            return `${parsed * -1}`;
        } else {
            return input;
        }
    }

    private getMessage(form: string, field: string): string | null {
        if (!this.formErrors.hasOwnProperty(form)) {
            return null;
        }

        if (!this.formErrors[form].hasOwnProperty(field)) {
            return null;
        }
        return this.formErrors[form][field].message;
    }

    private handleHttpError(err: any) {
        if (err && err.hasOwnProperty('response') && err.response != null) {
            if (err.response.data && err.response.data.errors && err.response.data.errors.length) {
                const errors = err.response.data as IErrors;
                this.renderErrors('updateSale', errors);
            } else if (err.response.data && typeof (err.response.data) === 'string') {
                this.showError(err.response.data);
                this.$log.error('Error occurred while save sale', err);
            } else {
                this.showError(this.$t('shared.parametersTab.errorSaveSaleOnSave') as string);
                this.$log.error('Error occurred while save sale', err);
            }
        } else {
            this.showError(this.$t('shared.parametersTab.errorSaveSaleOnSave') as string);
            this.$log.error('Error occurred while save sale', err);
        }
    }

    private renderErrors(form: string, errors: IErrors) {
        this.hideFormErrors(form)
        this.showFormError = true;
        errors.errors.forEach((e) => {
            this.formErrors[form][e.property] = e;
        });
    }

    private hideFormErrors(form: string) {
        this.formErrors[form] = {};
        this.showFormError = false;
    }

    private get allowToSave(): boolean {
        return !!(this.saleToEdit.name && this.saleToEdit.type && this.saleToEdit.status && this.saleToEdit.startDate && this.saleToEdit.endDate)
            && this.priceDecreaseLimitValidate && this.minPromoPriceValidate && this.minMarginValidate
            && this.minSaleDiscountValidate && this.maxSaleDiscountValidate;
    }

    private setParamsVerticalTabsHeight() {
        this.parametersTabsHeight = (this.$refs.parametersTabs as Vue).$el.scrollHeight * 1.1 + 'px';
    }

    private get isCalcButtonDisabled(): boolean {
        return !this.saleToEdit.id || !this.minMarginValidate
        || !this.minSaleDiscountValidate || !this.maxSaleDiscountValidate || this.currentSale.status === 'STOPPED' && this.isCalculationButtonLoading;
        // возможно и || !this.$sales.selectCoefficent.value.enum;
    }
    private get isSaveButtonDisabled(): boolean {
        return !this.allowToSave || this.saleToEdit.status === 'STOPPED';
    }

    private get isSaleEditStopped(): boolean {
        return this.saleToEdit.status === 'STOPPED';
    }

    handlePeriodForCalculatingChange(value: number | string) {
        this.periodForCalculatingEntered = value !== '' ? Number(value) : value;
    }

    handlePeriodForCalculatingFocusOut() {
        if (this.periodForCalculatingEntered === '') {
            this.periodForCalculatingEntered = null;
        }
    }

    disabledDatepickerDate(current: Moment, data: any, property: string) {
        if (current && current < moment().startOf('day')) return true;

        if (property === 'startDate') {
            if (data.endDate) {
                return current && current > moment(data.endDate).endOf('day')
            }
        }

        if (property === 'endDate') {
            if (data.startDate) {
                return current && current < moment(data.startDate).startOf('day')
            }
        }

        return false;
    }

    valueInRange(input: string, fromNumber: number, toNumber: number): number {
        const inputValue = isNaN(parseFloat(input)) ? 0 : parseFloat(input);

        if (inputValue > toNumber) {
            return toNumber;
        } else if (inputValue < fromNumber) {
            return fromNumber;
        } else {
            return inputValue;
        }
    }

    handleMaxSaleDiscountValueChanged() {
        if (this.saleToEdit.minSaleDiscount && isNumber(this.saleToEdit.maxSaleDiscount)
            && this.saleToEdit.maxSaleDiscount < this.saleToEdit.minSaleDiscount) {
            this.saleToEdit.minSaleDiscount = this.saleToEdit.maxSaleDiscount;
        }
    }

    private getTaskInfo(taskType: EntityFilterKeys): GetTaskInfo {
        return {
            type: taskType,
            tradingId: this.$sales.selectMarket.id,
            groups: this.entityFilters.groupIds,
            categories: this.entityFilters.categoryIds,
            subcategory: this.entityFilters.subcategoryId && this.entityFilters.subcategoryId !== 0 ? [this.entityFilters.subcategoryId] : null,
            storeFormat: this.entityFilters.formatId && this.entityFilters.formatId !== 0 ? [this.entityFilters.formatId] : null,
            storeRegion: this.entityFilters.regionIds,
            storeCluster: this.entityFilters.clusterIds,
            productSegments: null,
            segments: null,
            byReports: false,
        }
    }

    fetchEntityMaskSelectOptions(type: EntityFilterKeys, refValue: string) {
        this.$nextTick(() => {
            if (this.$refs[refValue]) {
                (this.$refs[refValue] as any).toggleLoading(true);
            }
        });

        this.httpGetProductInfo(this.getTaskInfo(type))
            .then(data => {
                const options = data.data ? data.data[ProductInfoResponseProperty[type]] : [];

                if (options.length) {
                    this.entityMaskOptions[this.entityMaskOptionPropertyNames[type] as keyof EntityMaskOptions] = [
                        { value: 0, label: this.$t('shared.selectBox.all') as string },
                        ...options.map((i) => {
                            return { value: i.id, label: i.name };
                        }),
                    ];
                } else {
                    this.entityMaskOptions[this.entityMaskOptionPropertyNames[type] as keyof EntityMaskOptions] = [{ value: 0, label: this.$t('shared.selectBox.all') as string }];
                }
            })
            .catch(() => {
                this.entityMaskOptions[this.entityMaskOptionPropertyNames[type] as keyof EntityMaskOptions] = [{ value: 0, label: this.$t('shared.selectBox.all') as string }];

                this.showError(this.$t('shared.parametersTab.errorLoadSelectOptions') as string);
            }).finally(() => {
                if (this.$refs[refValue]) {
                    (this.$refs[refValue] as any).toggleLoading(false);
                }
            });
    }

    updateEntityFiltersData(type: EntityFilterKeys) {
        const defaultMultiSelectValue: number[] = this.defaultIntSelectBox.map(i => i.value);

        switch (type) {
            case TaskInfoFilterType.group:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.category, 'entityCategoriesSelectRef');
                this.entityFilters.categoryIds = [...defaultMultiSelectValue];

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.subcategory, 'entitySubcategorySelectRef');
                this.entityFilters.subcategoryId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.format, 'entityFormatSelectRef');
                this.entityFilters.formatId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionsSelectRef');
                this.entityFilters.regionIds = [...defaultMultiSelectValue];

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClustersSelectRef');
                this.entityFilters.clusterIds = [...defaultMultiSelectValue];

                break;
            case TaskInfoFilterType.category:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.subcategory, 'entitySubcategorySelectRef');
                this.entityFilters.subcategoryId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.format, 'entityFormatSelectRef');
                this.entityFilters.formatId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionsSelectRef');
                this.entityFilters.regionIds = [...defaultMultiSelectValue];

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClustersSelectRef');
                this.entityFilters.clusterIds = [...defaultMultiSelectValue];

                break;
            case TaskInfoFilterType.subcategory:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.format, 'entityFormatSelectRef');
                this.entityFilters.formatId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionsSelectRef');
                this.entityFilters.regionIds = [...defaultMultiSelectValue];

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClustersSelectRef');
                this.entityFilters.clusterIds = [...defaultMultiSelectValue];

                break;
            case TaskInfoFilterType.format:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionsSelectRef');
                this.entityFilters.regionIds = [...defaultMultiSelectValue];

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClustersSelectRef');
                this.entityFilters.clusterIds = [...defaultMultiSelectValue];

                break;
            case TaskInfoFilterType.region:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClustersSelectRef');
                this.entityFilters.clusterIds = [...defaultMultiSelectValue];

                break;
        }
    }

    handleEntityFilterChanged(value: number[] | number, type: EntityFilterKeys) {
        if (Array.isArray(value)) {
            if (!!value.length && !LocalData.compareTwoArrays(value, this.entityFilters[this.entityFiltersPropertyNames[type] as keyof EntityFilters] as number[])) {
                this.entityFilters[this.entityFiltersPropertyNames[type] as keyof EntityFilters] = value.realValuesOrEmpty();

                this.updateEntityFiltersData(type);
            }
        } else {
            if (value !== this.entityFilters[this.entityFiltersPropertyNames[type] as keyof EntityFilters]) {
                this.entityFilters[this.entityFiltersPropertyNames[type] as keyof EntityFilters] = value;

                this.updateEntityFiltersData(type);
            }
        }
    }
}
